<template>
  <div class="home-container" :style="{ paddingBottom: paddingBottom }">
    <div v-if="activityInviteInfo.activityName" class="register-info-wrapper">
      <div class="info-detail">
        平台发布了新的活动：《{{
          activityInviteInfo.activityName
        }}》，活动时间{{
          activityInviteInfo.startTime + ' 至 ' + activityInviteInfo.endTime
        }}，现特邀您的参加。
      </div>
      <div class="info-detail">详询: {{ activityInviteInfo.telephone }}</div>
      <div class="info-detail to-register" @click="toRegister">
        请点击这条通知进入报名页面，挑选商品、配置专业，并完成相应报名。
      </div>
    </div>
    <div class="home-companyName">{{ companyName }}</div>
    <div class="home-index">
      <div>
        <span>易派客标准指数</span>
        <span>ESI（会员）</span>
        <span>：</span>
        <span>{{ info.scoreAll }}</span>
      </div>
      <div>
        <div>
          <div>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.4111 66.7025C32.5285 66.7694 32.6098 66.8236 32.655 66.8651C32.7001 66.9067 32.7326 66.9554 32.7525 67.0114C32.7724 67.0674 32.7778 67.1397 32.7706 67.23C32.7633 67.3203 32.7363 67.4594 32.6893 67.649L31.8205 71.2055C31.7717 71.4078 31.7248 71.5577 31.6832 71.6516C31.6417 71.7456 31.5857 71.8124 31.5134 71.8521C31.443 71.8919 31.3166 71.9117 31.1359 71.9154L31.0872 72.1176L34.8947 73.0479L35.3264 71.6245L34.92 71.5252C34.8188 71.6986 34.7412 71.8305 34.687 71.919C34.631 72.0093 34.5696 72.0924 34.5009 72.1718C34.4323 72.2513 34.3601 72.3109 34.286 72.3525C34.2119 72.394 34.1307 72.4157 34.0404 72.4193C33.95 72.4229 33.8399 72.4067 33.7044 72.3741L32.4256 72.0617L33.0054 69.6883L33.885 69.9032C34.0133 69.9339 34.1054 69.9755 34.1614 70.0278C34.2174 70.0784 34.2589 70.1525 34.2842 70.2482C34.3095 70.3439 34.3221 70.4776 34.3203 70.651L34.7069 70.7449L35.0934 69.1663L34.7069 69.0723C34.6238 69.2385 34.5479 69.3559 34.4829 69.4282C34.4179 69.4986 34.3456 69.5438 34.2697 69.5618C34.1921 69.5799 34.0945 69.5727 33.9735 69.5438L33.0939 69.3288L33.6213 67.174L34.92 67.4919C35.0266 67.5172 35.1169 67.5479 35.1909 67.5822C35.2632 67.6165 35.3228 67.6599 35.3697 67.7158C35.4149 67.77 35.4528 67.8387 35.4835 67.9181C35.5142 67.9976 35.5377 68.0933 35.5576 68.2071C35.5757 68.3191 35.5901 68.4474 35.5991 68.5919L36.0019 68.6912L36.3054 67.4485L32.4599 66.5093L32.4111 66.7025Z"
                fill="#040000"
              />
              <path
                d="M41.0395 67.7068C40.5265 67.6978 40.0822 67.8134 39.7083 68.0554C39.3344 68.2974 39.0472 68.6442 38.8503 69.094C38.6516 69.5455 38.5469 70.073 38.536 70.6762C38.5198 71.639 38.6896 72.3651 39.0472 72.8582C39.4048 73.3513 39.9431 73.6023 40.6602 73.615C40.9925 73.6204 41.2996 73.6096 41.5777 73.5789C41.8559 73.5482 42.1286 73.4994 42.396 73.4344L42.4176 72.2242L41.9986 72.217C41.9029 72.4951 41.8035 72.7046 41.7024 72.8473C41.5994 72.99 41.4748 73.093 41.3267 73.1562C41.1786 73.2194 40.9889 73.2501 40.7577 73.2465C40.4525 73.2411 40.1978 73.1363 39.9919 72.934C39.786 72.7317 39.6342 72.4337 39.5331 72.0418C39.4319 71.6498 39.3868 71.1766 39.3976 70.6239C39.4066 70.073 39.4807 69.6051 39.618 69.2204C39.7552 68.8357 39.9377 68.5467 40.1689 68.357C40.4001 68.1674 40.6602 68.0753 40.951 68.0807C41.1461 68.0843 41.3122 68.1186 41.4495 68.1836C41.5868 68.2487 41.706 68.3534 41.8071 68.5015C41.9083 68.6478 41.9914 68.8447 42.0546 69.0922L42.4736 69.0994L42.4935 67.9272C42.2153 67.8495 41.9679 67.7953 41.7511 67.7628C41.5344 67.7285 41.296 67.7104 41.0395 67.7068Z"
                fill="#040000"
              />
              <path
                d="M48.9924 71.2344C48.9599 71.527 48.9093 71.7528 48.8388 71.9136C48.7684 72.0743 48.6691 72.2026 48.539 72.2965C48.409 72.3904 48.2301 72.4609 48.0026 72.5078C47.7045 72.5674 47.4318 72.5223 47.1879 72.3687C46.9441 72.2152 46.7292 71.9587 46.5467 71.5957C46.3643 71.2344 46.2162 70.7829 46.106 70.2392C45.9958 69.6991 45.9669 69.2277 46.0157 68.8213C46.0663 68.4149 46.1819 68.0952 46.3661 67.8604C46.5503 67.6256 46.7852 67.4793 47.0705 67.4215C47.262 67.3817 47.43 67.3799 47.5781 67.4124C47.7262 67.4449 47.8653 67.5226 47.9971 67.6454C48.129 67.7665 48.2518 67.9417 48.3674 68.1692L48.7774 68.0862L48.5444 66.9374C48.2554 66.9211 48.0025 66.9211 47.784 66.9392C47.5654 66.9555 47.3306 66.9898 47.0796 67.0422C46.5756 67.1451 46.1674 67.3546 45.8549 67.6707C45.5425 67.9868 45.3384 68.3878 45.2408 68.8719C45.1451 69.3541 45.1577 69.8924 45.2769 70.4848C45.4684 71.4277 45.7935 72.1014 46.2487 72.5024C46.7057 72.9052 47.2837 73.0352 47.9863 72.8925C48.3132 72.8257 48.6076 72.7481 48.8732 72.6577C49.1387 72.5674 49.3933 72.4627 49.6408 72.3398L49.3988 71.1531L48.9924 71.2344Z"
                fill="#040000"
              />
              <path
                d="M19.6247 15.6023C19.6735 15.5897 19.7205 15.5879 19.7674 15.5987C19.8144 15.6096 19.8668 15.6366 19.9264 15.68C19.9842 15.7251 20.0691 15.8028 20.1793 15.9166L22.2474 18.0624C22.3648 18.1852 22.4479 18.281 22.4949 18.3514C22.5418 18.4219 22.5635 18.4887 22.5599 18.5537C22.5563 18.6187 22.5165 18.7145 22.4389 18.8409L22.5563 18.9619L24.852 16.7475L24.0591 15.8317L23.8134 16.0683C23.8893 16.2128 23.9453 16.323 23.9832 16.4007C24.0211 16.4784 24.0518 16.5578 24.0771 16.6391C24.1024 16.7204 24.1114 16.7962 24.1078 16.8649C24.1042 16.9335 24.0843 17.0004 24.0464 17.0618C24.0103 17.125 23.9507 17.1954 23.8694 17.2731L23.0981 18.0173L21.7182 16.5867L22.2492 16.0756C22.3269 15.9997 22.3955 15.9545 22.4551 15.9401C22.5147 15.9238 22.5834 15.9274 22.6592 15.9509C22.7351 15.9744 22.8344 16.025 22.9518 16.1008L23.1848 15.8769L22.2673 14.925L22.0343 15.149C22.1119 15.279 22.1607 15.382 22.1806 15.4578C22.2004 15.5337 22.2004 15.6023 22.1788 15.6619C22.1571 15.7215 22.1101 15.7884 22.0379 15.857L21.5068 16.3682L20.2533 15.0677L21.0372 14.3127C21.1022 14.2513 21.1618 14.2007 21.216 14.1664C21.2702 14.132 21.328 14.1086 21.3858 14.1013C21.4436 14.0941 21.5068 14.0977 21.5737 14.1104C21.6423 14.1248 21.7182 14.1501 21.8031 14.1844C21.888 14.2206 21.9837 14.2675 22.0848 14.3235L22.3287 14.0887L21.6062 13.3391L19.2906 15.577L19.408 15.6981C19.5037 15.6475 19.576 15.615 19.6247 15.6023Z"
                fill="#040000"
              />
              <path
                d="M22.9916 12.5462C23.0403 12.5408 23.0891 12.5462 23.1325 12.5642C23.1776 12.5823 23.2246 12.6166 23.277 12.669C23.3275 12.7214 23.3998 12.8117 23.4901 12.9417L25.2078 15.3784C25.3054 15.5174 25.3722 15.624 25.4083 15.7017C25.4444 15.7775 25.4553 15.848 25.4408 15.913C25.4264 15.978 25.3722 16.0665 25.2783 16.1767L25.3758 16.314L26.6113 15.4434L26.5137 15.3043C26.4072 15.3495 26.3241 15.3747 26.2663 15.3838C26.2085 15.3928 26.1525 15.3874 26.1001 15.3657C26.0477 15.3458 25.9917 15.3061 25.9339 15.2501C25.8761 15.1923 25.8075 15.1092 25.728 14.9972L25.0687 14.0616C25.1879 13.9876 25.3523 13.8792 25.5618 13.7311C25.7479 13.5992 25.9104 13.4529 26.0477 13.2904C26.1868 13.1278 26.2825 12.9526 26.3367 12.7665C26.3909 12.5805 26.3963 12.3836 26.3548 12.1813C26.3132 11.9772 26.2229 11.7785 26.0856 11.5835C25.8436 11.2403 25.5564 11.0597 25.2223 11.0434C24.8881 11.0271 24.5034 11.1734 24.0627 11.4823L22.6664 12.4667L22.764 12.604C22.8651 12.5715 22.9428 12.5516 22.9916 12.5462ZM24.115 11.8183C24.2397 11.7316 24.3625 11.6647 24.4871 11.6178C24.6118 11.5708 24.7346 11.5528 24.8574 11.5654C24.9802 11.578 25.1013 11.6232 25.2205 11.7009C25.3397 11.7785 25.4571 11.8977 25.5709 12.0585C25.7208 12.2698 25.8039 12.4667 25.8219 12.6473C25.84 12.828 25.7985 12.9941 25.6991 13.1459C25.5998 13.2976 25.4444 13.4493 25.2331 13.5992L24.9062 13.8286L23.705 12.1253C23.7917 12.0531 23.929 11.9501 24.115 11.8183Z"
                fill="#040000"
              />
              <path
                d="M26.7449 10.0644C26.7955 10.0662 26.8406 10.0807 26.8822 10.1042C26.9237 10.1276 26.9653 10.171 27.0086 10.2306C27.0502 10.2902 27.108 10.3914 27.1784 10.5322L28.5024 13.2019C28.5782 13.3536 28.627 13.471 28.6505 13.5505C28.674 13.6317 28.674 13.7022 28.6505 13.7636C28.627 13.825 28.5602 13.9045 28.4482 14.0002L28.5241 14.1519L31.3815 12.734L30.9029 11.6214L30.5976 11.7731C30.6265 11.9339 30.6464 12.0567 30.659 12.1416C30.6717 12.2265 30.6771 12.3114 30.6753 12.3963C30.6735 12.4812 30.6608 12.557 30.6374 12.6202C30.6139 12.6853 30.5741 12.7413 30.5199 12.79C30.4658 12.8388 30.3881 12.8876 30.2869 12.9381L29.3278 13.415L28.4446 11.634L29.1057 11.3053C29.2032 11.2565 29.2809 11.2349 29.3423 11.2367C29.4037 11.2403 29.4669 11.2638 29.5337 11.3089C29.6006 11.3541 29.6782 11.4317 29.7686 11.5401L30.0594 11.3956L29.4705 10.2107L29.1797 10.3552C29.214 10.5015 29.2303 10.6153 29.2267 10.693C29.2231 10.7725 29.2032 10.8357 29.1635 10.8881C29.1255 10.9386 29.0605 10.9874 28.9702 11.0326L28.3091 11.3595L27.5071 9.74291L28.4825 9.25884C28.562 9.2191 28.6342 9.1902 28.6975 9.17395C28.7607 9.15589 28.8203 9.15227 28.8781 9.16311C28.9359 9.17395 28.9937 9.19562 29.0551 9.22994C29.1165 9.26426 29.1815 9.31122 29.252 9.37083C29.3224 9.43043 29.3983 9.50268 29.4796 9.58938L29.7812 9.43946L29.3188 8.50745L26.4324 9.93979L26.5083 10.0915C26.6167 10.0716 26.6943 10.0626 26.7449 10.0644Z"
                fill="#040000"
              />
              <path
                d="M32.2702 11.8345C32.6748 12.1199 33.1552 12.1741 33.7116 11.9971C33.9698 11.914 34.2029 11.8255 34.4088 11.7298C34.6147 11.6341 34.8134 11.5257 35.0012 11.4047L34.7014 10.4654L34.3763 10.5702C34.3763 10.8086 34.3546 10.9964 34.3112 11.1337C34.2679 11.271 34.1992 11.383 34.1017 11.4697C34.0042 11.5564 33.8651 11.6304 33.6863 11.6882C33.4497 11.7641 33.2257 11.7496 33.0144 11.6485C32.803 11.5455 32.6079 11.3559 32.4273 11.0795C32.2467 10.8032 32.0896 10.451 31.9523 10.0211C31.8168 9.59481 31.75 9.2155 31.7554 8.88135C31.759 8.549 31.8258 8.27806 31.9541 8.07215C32.0823 7.86624 32.2593 7.72716 32.4851 7.65491C32.6368 7.60614 32.7723 7.58989 32.8951 7.60253C33.018 7.61698 33.1372 7.66756 33.2546 7.75426C33.372 7.84095 33.4858 7.971 33.5996 8.1444L33.9247 8.03964L33.6339 7.1311C33.3991 7.14375 33.195 7.16542 33.0198 7.19974C32.8446 7.23225 32.6567 7.28102 32.458 7.34424C32.0589 7.47248 31.7482 7.67659 31.5224 7.96197C31.2966 8.24555 31.1666 8.58874 31.1323 8.98791C31.0979 9.38709 31.1539 9.82059 31.3038 10.2902C31.5441 11.0326 31.8656 11.5492 32.2702 11.8345Z"
                fill="#040000"
              />
              <path
                d="M36.8906 8.09923C36.9845 8.23831 37.1145 8.36294 37.2843 8.47312C37.4541 8.5833 37.6799 8.68806 37.9616 8.79101C38.2525 8.89758 38.4728 8.99331 38.6173 9.08182C38.7618 9.17032 38.872 9.26786 38.946 9.37804C39.0183 9.48822 39.0635 9.6273 39.0833 9.79889C39.114 10.0662 39.0653 10.2775 38.937 10.4329C38.8106 10.5882 38.6137 10.6803 38.3464 10.711C38.1531 10.7327 37.9905 10.7219 37.8605 10.6803C37.7304 10.6388 37.6203 10.5629 37.53 10.4564C37.4396 10.348 37.3602 10.1963 37.2915 10.0012L36.9483 10.0391L37.0531 10.9784C37.5354 11.047 37.9544 11.0615 38.3139 11.0217C38.536 10.9964 38.7365 10.9513 38.9171 10.8826C39.0978 10.814 39.2495 10.7219 39.3705 10.6027C39.4915 10.4835 39.5818 10.3372 39.6378 10.1638C39.6956 9.99035 39.7101 9.78264 39.683 9.54241C39.6595 9.32747 39.5927 9.14504 39.4843 8.99331C39.3759 8.84339 39.235 8.71335 39.0598 8.60497C38.8846 8.4984 38.6426 8.38642 38.3355 8.27443C38.0809 8.18231 37.8858 8.09561 37.7521 8.01433C37.6185 7.93305 37.5155 7.83913 37.4451 7.73256C37.3746 7.6278 37.3295 7.49414 37.3114 7.33158C37.2933 7.17805 37.3132 7.04258 37.3692 6.92517C37.4252 6.80596 37.5083 6.71384 37.6203 6.64521C37.7323 6.57657 37.8623 6.53503 38.0104 6.51877C38.182 6.4989 38.3229 6.50613 38.4349 6.53864C38.5469 6.57115 38.6498 6.63798 38.7419 6.74094C38.8341 6.84389 38.9171 6.992 38.993 7.18708L39.3326 7.14915L39.2296 6.22435C38.9731 6.18823 38.7618 6.17017 38.5938 6.17017C38.4259 6.17017 38.2561 6.181 38.0827 6.19907C37.7828 6.23158 37.5245 6.31286 37.3042 6.44291C37.0838 6.57296 36.9249 6.73732 36.8255 6.93782C36.7262 7.14011 36.6919 7.3677 36.7208 7.62419C36.7406 7.803 36.7966 7.96015 36.8906 8.09923Z"
                fill="#040000"
              />
              <path
                d="M40.6655 9.76276C40.6655 10.1366 40.7378 10.413 40.8823 10.5882C41.0268 10.7634 41.2472 10.8519 41.5434 10.8519C41.7005 10.8519 41.8504 10.8158 41.9967 10.7453C42.143 10.6749 42.2966 10.5593 42.4609 10.4004L42.3056 10.2143C42.2279 10.2848 42.1485 10.3408 42.0672 10.3787C41.9859 10.4166 41.901 10.4347 41.8089 10.4347C41.7077 10.4347 41.6247 10.4184 41.5614 10.3859C41.4964 10.3534 41.4404 10.301 41.3898 10.2252C41.3393 10.1511 41.305 10.0463 41.2869 9.91448C41.2688 9.78262 41.2598 9.60561 41.2598 9.38164V7.84815H42.3724V7.49954H41.2598V6.6488H40.7703C40.745 6.85833 40.7215 7.01728 40.6981 7.12565C40.6746 7.23402 40.6439 7.32614 40.6041 7.39839C40.5644 7.47064 40.5084 7.53025 40.4362 7.5754C40.3657 7.62056 40.2718 7.65307 40.1562 7.67113V7.84634H40.6655V9.76276Z"
                fill="#040000"
              />
              <path
                d="M42.9667 10.7905C43.0913 10.8718 43.2412 10.9242 43.4146 10.9422C43.6115 10.9639 43.8012 10.9422 43.9854 10.8772C44.1697 10.8122 44.372 10.6894 44.5941 10.5087L44.6447 10.5286L44.5724 11.0163L45.5099 11.121L45.528 10.9531C45.4304 10.9151 45.3618 10.8808 45.3184 10.8501C45.2769 10.8194 45.2462 10.7869 45.2281 10.749C45.2082 10.711 45.1974 10.6623 45.192 10.6008C45.1866 10.5412 45.1884 10.4744 45.1938 10.4058C45.1992 10.3353 45.2119 10.2161 45.2299 10.0481L45.3636 8.85602C45.3979 8.55619 45.3871 8.33041 45.3365 8.17326C45.2859 8.01612 45.1938 7.8951 45.0656 7.8084C44.9373 7.72171 44.7585 7.66571 44.5327 7.64042C44.3828 7.62417 44.2311 7.62236 44.083 7.63681C43.933 7.65126 43.7831 7.67655 43.6314 7.71448C43.4797 7.75241 43.2882 7.81563 43.0552 7.90414L43.0046 8.34847L43.4526 8.39904C43.5284 8.21842 43.626 8.08657 43.7452 8.00528C43.8644 7.924 44.0125 7.8933 44.1913 7.91317C44.3557 7.93123 44.4839 7.97819 44.5743 8.05225C44.6646 8.1263 44.726 8.23468 44.7567 8.37737C44.7874 8.52006 44.7892 8.70972 44.7621 8.94633L44.7368 9.1685C44.0739 9.12515 43.5664 9.17392 43.2178 9.32023C42.8674 9.46472 42.6741 9.70315 42.6362 10.0373C42.6181 10.1963 42.638 10.3426 42.6958 10.4726C42.7499 10.6008 42.8421 10.7074 42.9667 10.7905ZM43.2358 10.0174C43.2629 9.7772 43.3984 9.61103 43.6422 9.51891C43.8861 9.42679 44.2401 9.40331 44.7043 9.45027L44.6501 9.93254C44.6375 10.0463 44.5887 10.1583 44.5056 10.2667C44.4225 10.3751 44.3123 10.46 44.1769 10.5214C44.0414 10.5828 43.8969 10.6045 43.7416 10.5864C43.6314 10.5738 43.5393 10.5485 43.4616 10.5123C43.3857 10.4744 43.3243 10.4148 43.281 10.3335C43.2358 10.2522 43.2214 10.1475 43.2358 10.0174Z"
                fill="#040000"
              />
              <path
                d="M47.2114 11.3505C47.1048 11.2927 47.0326 11.2385 46.9928 11.1861C46.9531 11.1337 46.9332 11.0687 46.935 10.9892C46.9368 10.9098 46.9621 10.7743 47.0109 10.5828L47.3306 9.33834C47.3577 9.23177 47.4029 9.14327 47.4661 9.07102C47.5293 9.00058 47.6196 8.93375 47.7334 8.87233C47.849 8.81273 47.9501 8.7748 48.0368 8.76035C48.1235 8.7459 48.2102 8.74951 48.2969 8.77299C48.3836 8.79467 48.4505 8.82357 48.4992 8.85608C48.548 8.88859 48.5877 8.92652 48.6221 8.96987C48.6546 9.01322 48.6799 9.06018 48.6979 9.11437C48.716 9.16675 48.725 9.23719 48.7268 9.32389C48.7268 9.41059 48.716 9.51897 48.6925 9.64721C48.669 9.77545 48.6365 9.91814 48.5968 10.0735L48.3728 10.9477C48.3349 11.0994 48.2969 11.2096 48.2644 11.28C48.2301 11.3505 48.1958 11.4011 48.1615 11.43C48.1272 11.4589 48.0874 11.4787 48.0441 11.4896C48.0007 11.5004 47.9321 11.5076 47.84 11.5112L47.7984 11.6756L49.1134 12.0134L49.1549 11.8508C49.0574 11.7948 48.9905 11.7497 48.9562 11.7117C48.9201 11.6756 48.8966 11.6359 48.884 11.5925C48.8713 11.5492 48.8695 11.4914 48.8785 11.4209C48.8876 11.3505 48.9111 11.2367 48.9508 11.0832L49.2741 9.82422C49.3211 9.63998 49.35 9.48465 49.3572 9.35821C49.3644 9.23177 49.3554 9.11979 49.3319 9.02225C49.3084 8.92471 49.2651 8.83802 49.2091 8.76035C49.1513 8.68449 49.079 8.61946 48.9923 8.56708C48.9056 8.5147 48.8009 8.47316 48.6817 8.44245C48.5661 8.41355 48.4523 8.40452 48.3385 8.41716C48.2247 8.42981 48.1091 8.45871 47.9899 8.50386C47.8707 8.54902 47.7063 8.63391 47.4986 8.75854L47.4552 8.73325L47.6322 8.19861L47.4281 8.14623L46.6388 7.97644L46.5937 8.15345C46.6894 8.1968 46.7616 8.23835 46.8086 8.27808C46.8574 8.31782 46.8881 8.36659 46.9007 8.42619C46.9134 8.4858 46.9116 8.55805 46.8935 8.64655C46.8754 8.73506 46.8483 8.84885 46.8122 8.99154L46.4383 10.4456C46.3986 10.6009 46.3625 10.7147 46.3281 10.7833C46.2956 10.8538 46.2613 10.9025 46.227 10.9314C46.1927 10.9603 46.1547 10.9802 46.1114 10.991C46.0699 11.0019 46.0012 11.0091 45.9091 11.0127L45.8676 11.1771L47.1753 11.5131L47.2114 11.3505Z"
                fill="#040000"
              />
              <path
                d="M50.58 12.669C50.7065 12.7232 50.8347 12.7521 50.9629 12.7557C51.0912 12.7611 51.2212 12.7485 51.3495 12.7196C51.4777 12.6907 51.6385 12.6329 51.8317 12.548L51.8733 12.5805L51.615 13.0844L51.8046 13.1657L52.5669 13.4511L52.6373 13.2867C52.5326 13.2145 52.4639 13.1567 52.4296 13.1115C52.3953 13.0664 52.3772 13.0176 52.3736 12.967C52.37 12.9165 52.3808 12.8532 52.4043 12.7792C52.4278 12.7051 52.4748 12.5859 52.5434 12.4216L54.0968 8.74586L53.9089 8.66639L53.1268 8.37378L53.0564 8.53995C53.1557 8.60498 53.2225 8.65555 53.2551 8.69168C53.2876 8.7278 53.311 8.76754 53.3219 8.80908C53.3327 8.85063 53.3327 8.90301 53.3237 8.96442C53.3147 9.02583 53.293 9.09808 53.2623 9.17936C53.2316 9.26064 53.1738 9.40333 53.0871 9.60744L52.8739 10.1114C52.7746 10.0102 52.6734 9.92353 52.5687 9.85309C52.4639 9.78264 52.3411 9.71762 52.202 9.65801C51.9419 9.54783 51.6818 9.5081 51.4235 9.5388C51.1652 9.56951 50.9232 9.67969 50.6992 9.86934C50.4735 10.059 50.2874 10.3281 50.1411 10.6749C49.9316 11.1716 49.8647 11.5925 49.9424 11.9357C50.0219 12.2771 50.2332 12.5227 50.58 12.669ZM50.7787 10.8375C50.9503 10.4311 51.1526 10.1493 51.3856 9.99217C51.6186 9.83502 51.8715 9.81335 52.1424 9.92895C52.2418 9.97049 52.323 10.0175 52.3844 10.068C52.4459 10.1186 52.4964 10.18 52.5362 10.2523C52.5759 10.3245 52.5994 10.4004 52.6048 10.4835C52.612 10.5665 52.6012 10.6605 52.5741 10.7652C52.547 10.87 52.4982 11.0055 52.4296 11.1716L52.1298 11.8815C52.0864 11.9863 52.0431 12.0675 51.9997 12.1253C51.9564 12.1849 51.9112 12.2337 51.8606 12.2716C51.8101 12.3096 51.7414 12.3475 51.6547 12.3836C51.568 12.4197 51.4868 12.4414 51.4127 12.4523C51.3386 12.4613 51.2682 12.4613 51.1996 12.4523C51.1309 12.4414 51.0514 12.4179 50.9575 12.3782C50.7209 12.2789 50.589 12.0982 50.562 11.8363C50.5331 11.578 50.6071 11.2439 50.7787 10.8375Z"
                fill="#040000"
              />
              <path
                d="M55.1028 11.578C55.2455 11.5528 55.3918 11.5871 55.5472 11.6774C55.6899 11.7623 55.7856 11.858 55.838 11.9628C55.8904 12.0675 55.8994 12.1922 55.8687 12.3349C55.838 12.4775 55.7603 12.6509 55.6375 12.855L55.5237 13.0465C54.9385 12.7322 54.4562 12.5679 54.0769 12.5552C53.6976 12.5426 53.423 12.6798 53.2514 12.967C53.1683 13.1061 53.1268 13.2452 53.125 13.3879C53.1232 13.5306 53.1629 13.6642 53.2424 13.7907C53.3219 13.9171 53.4375 14.0255 53.5874 14.114C53.7572 14.2151 53.9396 14.2748 54.1329 14.291C54.328 14.3073 54.5628 14.2802 54.8391 14.2061L54.877 14.244L54.6097 14.6577L55.4207 15.1417L55.5074 14.9972C55.4352 14.9214 55.3864 14.8618 55.3593 14.8166C55.334 14.7715 55.3196 14.7281 55.3196 14.6866C55.3178 14.6432 55.3268 14.5945 55.3485 14.5367C55.3701 14.4789 55.3972 14.4211 55.4316 14.3596C55.4659 14.2982 55.5255 14.1953 55.6122 14.049L56.2263 13.0194C56.3798 12.7611 56.4665 12.5498 56.4828 12.3872C56.5009 12.2247 56.4683 12.0766 56.3871 11.9429C56.3058 11.8092 56.1667 11.6846 55.9716 11.569C55.8416 11.4913 55.7061 11.4281 55.5634 11.3794C55.4207 11.3306 55.2726 11.2927 55.1191 11.2638C54.9656 11.2349 54.7633 11.2132 54.5158 11.1987L54.2864 11.5835L54.6748 11.8147C54.8193 11.6828 54.9619 11.6033 55.1028 11.578ZM55.1299 13.7076C55.0703 13.8069 54.9818 13.8882 54.859 13.9514C54.7362 14.0147 54.6025 14.0472 54.4544 14.0472C54.3063 14.0472 54.1654 14.0074 54.0299 13.9261C53.9342 13.8702 53.8601 13.8087 53.806 13.7419C53.7518 13.6769 53.7211 13.5974 53.7138 13.5053C53.7066 13.4132 53.7373 13.3102 53.8041 13.1982C53.927 12.9905 54.1202 12.8966 54.3803 12.9128C54.6404 12.9291 54.9728 13.0555 55.3756 13.2904L55.1299 13.7076Z"
                fill="#040000"
              />
              <path
                d="M56.3058 15.2031C56.248 15.2537 56.1974 15.2862 56.1541 15.2989C56.1089 15.3115 56.0656 15.3133 56.024 15.3079C55.9807 15.3007 55.9174 15.2826 55.8307 15.2501L55.7278 15.3838L56.826 16.2327L56.9289 16.099C56.8495 16.0105 56.7971 15.9347 56.7736 15.8697C56.7501 15.8046 56.7519 15.7342 56.7808 15.6547C56.8097 15.577 56.8874 15.4542 57.0156 15.2898L57.7526 14.3343C57.8194 14.2477 57.8898 14.1808 57.9621 14.1339C58.0343 14.0887 58.1283 14.0508 58.2439 14.0255C58.3595 13.9984 58.4642 13.9912 58.56 14.0038C58.6539 14.0146 58.7334 14.0472 58.8002 14.0977C58.8851 14.1646 58.9357 14.2386 58.9501 14.3199C58.9646 14.403 58.9555 14.5096 58.923 14.6414L59.2319 14.8798L59.716 14.2531C59.6383 14.1772 59.548 14.0977 59.4414 14.0165C59.3168 13.9189 59.1885 13.8521 59.0603 13.8142C58.932 13.7762 58.7984 13.7582 58.6575 13.7618C58.5184 13.7654 58.3504 13.7907 58.1572 13.834L58.1247 13.7961L58.5238 13.3427L58.3577 13.2145L57.6984 12.7485L57.5882 12.8894C57.6586 12.967 57.7074 13.0339 57.7363 13.0899C57.7652 13.1458 57.7724 13.2018 57.7616 13.2614C57.7508 13.3211 57.7201 13.3879 57.6677 13.4619C57.6153 13.536 57.5467 13.6299 57.4564 13.7473L56.5388 14.9358C56.4394 15.0623 56.3618 15.1508 56.3058 15.2031Z"
                fill="#040000"
              />
              <path
                d="M58.3342 16.9733C58.2782 17.3201 58.383 17.6272 58.6503 17.8927C58.7478 17.9902 58.8562 18.0643 58.9736 18.1167C59.091 18.169 59.2156 18.2052 59.3457 18.2268C59.4757 18.2485 59.6455 18.2539 59.8569 18.2467L59.884 18.2937L59.4559 18.6658L59.6022 18.8121L60.2037 19.3612L60.3301 19.2347C60.2596 19.13 60.2181 19.0487 60.2018 18.9945C60.1874 18.9403 60.1874 18.8879 60.2037 18.8392C60.2199 18.7904 60.2524 18.7362 60.3012 18.6766C60.35 18.617 60.4385 18.5231 60.5649 18.3966L63.3772 15.5681L63.2327 15.4254L62.6168 14.8618L62.4903 14.9883C62.559 15.0858 62.6023 15.1562 62.6186 15.2032C62.6348 15.2502 62.6421 15.2935 62.6367 15.3369C62.6312 15.3802 62.6114 15.429 62.5807 15.4814C62.5481 15.5355 62.503 15.5933 62.4434 15.6584C62.3838 15.7234 62.2772 15.8336 62.1219 15.9889L61.7353 16.3772C61.6812 16.2454 61.6197 16.128 61.5475 16.0232C61.4771 15.9185 61.3867 15.8137 61.2802 15.7053C61.0797 15.5066 60.8539 15.373 60.6028 15.3043C60.3518 15.2357 60.0862 15.2484 59.8063 15.3405C59.5263 15.4326 59.2536 15.6132 58.9881 15.8805C58.6087 16.2617 58.3902 16.6265 58.3342 16.9733ZM60.3951 15.7089C60.6697 15.6511 60.9117 15.7252 61.1212 15.9329C61.1971 16.0088 61.2549 16.0828 61.2928 16.1533C61.3307 16.2237 61.356 16.2996 61.3651 16.3809C61.3759 16.4621 61.3669 16.5416 61.3434 16.6211C61.3181 16.7006 61.2729 16.7837 61.2097 16.8704C61.1447 16.9589 61.049 17.0654 60.9225 17.1937L60.3789 17.741C60.2994 17.8204 60.2289 17.88 60.1675 17.9198C60.1061 17.9595 60.0447 17.9866 59.9833 18.0047C59.9219 18.0227 59.8442 18.03 59.7503 18.03C59.6564 18.03 59.5733 18.0209 59.501 18.0029C59.4288 17.9848 59.3638 17.9577 59.3041 17.9234C59.2445 17.8891 59.1795 17.8367 59.1073 17.7644C58.9248 17.5838 58.8706 17.3671 58.9429 17.1142C59.0151 16.8613 59.2066 16.5795 59.5173 16.2671C59.828 15.9546 60.1206 15.7685 60.3951 15.7089Z"
                fill="#040000"
              />
              <path
                d="M39.9991 0C17.9088 0 0 17.9088 0 39.9991C0 62.0894 17.9088 79.9982 39.9991 79.9982C62.0894 79.9982 79.9982 62.0894 79.9982 39.9991C79.9982 17.9088 62.0912 0 39.9991 0ZM39.9991 77.4984C19.2888 77.4984 2.49983 60.7094 2.49983 39.9991C2.49983 19.2888 19.2888 2.49983 39.9991 2.49983C60.7094 2.49983 77.4984 19.2888 77.4984 39.9991C77.4984 60.7094 60.7094 77.4984 39.9991 77.4984Z"
                fill="#51ACE0"
              />
              <path
                d="M39.5024 31.0149L37.0369 31.3743L38.8214 33.1137L38.4006 35.5702L40.606 34.4106L42.8132 35.5702L42.3905 33.1137L44.1769 31.3743L41.7096 31.0149L40.606 28.7806L39.5024 31.0149Z"
                fill="#51ACE0"
              />
              <path
                d="M40.8426 24.6606L40.7342 24.6425L40.624 24.6588C38.9731 24.9098 33.195 26.0731 28.2206 30.5417L27.9767 30.7602L27.9822 31.0872C28.0436 35.0988 29.1237 48.5354 40.4741 53.0149L40.7378 53.1178L41.0015 53.0149C46.3877 50.898 50.1158 46.5666 52.0846 40.1454C53.2424 36.3722 53.4627 32.8519 53.4916 31.0872L53.4971 30.7602L53.2532 30.5417C48.3132 26.1164 42.5043 24.9207 40.8426 24.6606ZM50.7136 39.7246C48.911 45.6021 45.5568 49.5866 40.7396 51.5735C30.7475 47.4336 29.5373 35.4998 29.4253 31.3942C34.0312 27.3898 39.4193 26.3079 40.7306 26.0965C42.0491 26.3151 47.4715 27.4259 52.0503 31.3942C51.9997 33.1661 51.7504 36.3415 50.7136 39.7246Z"
                fill="#51ACE0"
              />
              <path
                d="M40.7378 15.1561C26.9815 15.1561 15.8298 26.3078 15.8298 40.0641C15.8298 53.8204 26.9815 64.9721 40.7378 64.9721C54.4941 64.9721 65.6458 53.8204 65.6458 40.0641C65.6458 26.3078 54.4941 15.1561 40.7378 15.1561ZM40.7378 55.399C40.7703 55.4098 40.8029 55.4225 40.8354 55.4333H40.6403C40.6728 55.4225 40.7053 55.4098 40.7378 55.399C24.7129 50.0471 25.8436 29.8299 25.8436 29.8299C32.3352 23.3383 40.7378 22.4731 40.7378 22.4731C40.7378 22.4731 49.1404 23.3383 55.6321 29.8299C55.6321 29.8299 56.7628 50.0471 40.7378 55.399Z"
                fill="#51ACE0"
              />
            </svg>
          </div>
          <div>
            <div>法人信用认证</div>
            <div
              v-if="!info.showCredit"
              class="btn-80-30"
              @click="
                jump(
                  easySeries +
                    '/ecmall/creditRating/supplierCreditRating.do?isFirstApply=1'
                )
              "
            >
              申 请
            </div>
            <div v-else>信用等级：{{ info.creditGrade }}</div>
          </div>
        </div>
        <div>
          <div>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.4112 66.7025C32.5286 66.7693 32.6099 66.8235 32.655 66.8651C32.7002 66.9066 32.7327 66.9554 32.7525 67.0114C32.7724 67.0674 32.7778 67.1396 32.7706 67.2299C32.7634 67.3202 32.7363 67.4593 32.6893 67.649L31.8187 71.2054C31.77 71.4077 31.723 71.5577 31.6814 71.6516C31.6399 71.7455 31.5839 71.8123 31.5117 71.8521C31.4394 71.8918 31.3148 71.9117 31.1342 71.9153L31.0854 72.1176L34.8929 73.0478L35.3246 71.6245L34.9182 71.5251C34.8171 71.6985 34.7394 71.8286 34.6852 71.9189C34.6292 72.0092 34.5678 72.0923 34.4992 72.1718C34.4305 72.2513 34.3583 72.3109 34.2842 72.3524C34.2102 72.3939 34.1289 72.4156 34.0386 72.4192C33.9483 72.4228 33.8381 72.4066 33.7026 72.3741L32.4238 72.0616L33.0036 69.6882L33.8832 69.9031C34.0115 69.9339 34.1036 69.9754 34.1596 70.0278C34.2156 70.0802 34.2571 70.1524 34.2824 70.2481C34.3077 70.3439 34.3204 70.4775 34.3186 70.6509L34.7051 70.7449L35.0916 69.1662L34.7051 69.0723C34.6202 69.2385 34.5461 69.3559 34.4811 69.4263C34.4161 69.4967 34.3438 69.5419 34.268 69.56C34.1903 69.578 34.0928 69.5708 33.9718 69.5419L33.0921 69.327L33.6195 67.1721L34.9182 67.49C35.0248 67.5153 35.1151 67.546 35.1892 67.5803C35.2614 67.6146 35.3228 67.658 35.368 67.714C35.4131 67.77 35.4511 67.8368 35.4818 67.9163C35.5125 67.9958 35.536 68.0915 35.5558 68.2035C35.5757 68.3155 35.5883 68.4437 35.5974 68.5882L36.0002 68.6875L36.3036 67.4449L32.4581 66.5056L32.4112 66.7025Z"
                fill="#040000"
              />
              <path
                d="M43.1257 74.5325C43.0119 74.5903 42.8783 74.6174 42.7229 74.6174C42.667 74.6174 42.6073 74.6065 42.5459 74.5849C42.4845 74.5632 42.4177 74.5271 42.3491 74.4783C42.2804 74.4277 42.2064 74.3627 42.1305 74.2832C42.0528 74.202 41.9806 74.1171 41.9137 74.0286C41.8469 73.9382 41.7747 73.8389 41.6988 73.7287L41.5525 73.512C42.0871 73.3512 42.4954 73.0207 42.7771 72.5203C43.0589 72.02 43.2016 71.3788 43.2052 70.5931C43.2088 69.9754 43.1239 69.4497 42.9523 69.0199C42.7807 68.5882 42.5243 68.2612 42.1829 68.0391C41.8415 67.8151 41.4188 67.7031 40.9167 67.7013C40.4453 67.6995 40.0298 67.8151 39.6722 68.0481C39.3146 68.2829 39.0382 68.6243 38.8449 69.0759C38.6517 69.5274 38.5523 70.0675 38.5505 70.696C38.5469 71.61 38.7239 72.3162 39.0798 72.8111C39.4356 73.3061 39.9666 73.5734 40.6693 73.6095L40.9673 74.0556C41.1335 74.3049 41.278 74.5018 41.4044 74.6463C41.5308 74.7908 41.6446 74.8992 41.7476 74.9696C41.8505 75.04 41.9535 75.0924 42.0582 75.1231C42.163 75.1538 42.2949 75.1701 42.4556 75.1719C42.6561 75.1719 42.8512 75.1249 43.0408 75.031C43.2305 74.9353 43.4364 74.7781 43.6568 74.5596L43.4545 74.2959C43.3479 74.397 43.2395 74.4765 43.1257 74.5325ZM40.8914 73.2428C40.4055 73.241 40.0389 73.0134 39.7878 72.5601C39.5367 72.1067 39.4139 71.4474 39.4175 70.5805C39.4193 70.1993 39.4482 69.8543 39.5042 69.5437C39.5602 69.233 39.6487 68.9693 39.7697 68.7507C39.8908 68.5322 40.0425 68.3642 40.2249 68.2468C40.4073 68.1294 40.6259 68.0716 40.8806 68.0716C41.1678 68.0734 41.4206 68.1655 41.6374 68.3498C41.8541 68.534 42.0239 68.8284 42.1486 69.2348C42.2714 69.6412 42.3328 70.1506 42.3292 70.7665C42.3274 71.2722 42.2714 71.713 42.1612 72.0905C42.0528 72.468 41.8903 72.7552 41.6753 72.9502C41.4604 73.1471 41.2003 73.2446 40.8914 73.2428Z"
                fill="#040000"
              />
              <path
                d="M49.9335 70.8461C49.9226 71.0466 49.9118 71.1983 49.9028 71.303C49.8937 71.4078 49.8775 71.5108 49.8522 71.6137C49.8269 71.7149 49.7908 71.8016 49.7438 71.872C49.6968 71.9425 49.6336 72.0003 49.556 72.0418C49.4783 72.0851 49.3717 72.1231 49.2362 72.1538L47.9538 72.4536L47.3957 70.0748L48.2771 69.8671C48.4054 69.8364 48.5065 69.8328 48.5806 69.8526C48.6546 69.8725 48.7233 69.9195 48.7901 69.9935C48.8569 70.0658 48.9274 70.1814 49.0051 70.3367L49.3916 70.2464L49.0213 68.6641L48.633 68.7544C48.633 68.9405 48.6203 69.0796 48.5932 69.1717C48.5679 69.2656 48.5246 69.3361 48.4632 69.3866C48.4018 69.4372 48.3115 69.4769 48.1904 69.504L47.309 69.7099L46.8033 67.5533L48.1055 67.248C48.2121 67.2228 48.306 67.2083 48.3873 67.2065C48.4686 67.2029 48.5408 67.2155 48.6077 67.2444C48.6745 67.2733 48.7377 67.3149 48.8009 67.3727C48.8642 67.4305 48.9292 67.5045 48.996 67.5966C49.0647 67.687 49.1333 67.7953 49.2073 67.9218L49.6119 67.826L49.3193 66.5815L45.4666 67.4847L45.5136 67.687C45.6491 67.6924 45.7448 67.705 45.8044 67.7213C45.864 67.7375 45.9146 67.7664 45.9561 67.808C45.9995 67.8477 46.0374 67.9109 46.0717 67.994C46.1061 68.0771 46.1458 68.2144 46.1891 68.404L47.0254 71.9695C47.0724 72.1737 47.0995 72.3254 47.1049 72.4283C47.1103 72.5313 47.0904 72.6162 47.0453 72.683C47.0001 72.7498 46.8972 72.8257 46.7382 72.9088L46.7852 73.1111L50.6018 72.2152L50.3417 70.7503L49.9335 70.8461Z"
                fill="#040000"
              />
              <path
                d="M19.6248 15.6023C19.6736 15.5897 19.7205 15.5879 19.7675 15.5987C19.8145 15.6096 19.8668 15.6367 19.9264 15.68C19.9842 15.7252 20.0691 15.8028 20.1793 15.9166L22.2475 18.0624C22.3649 18.1853 22.4479 18.281 22.4949 18.3514C22.5419 18.4219 22.5635 18.4887 22.5599 18.5537C22.5563 18.6188 22.5166 18.7145 22.4389 18.8409L22.5563 18.9619L24.852 16.7475L24.0591 15.8317L23.8135 16.0684C23.8893 16.2129 23.9453 16.323 23.9833 16.4007C24.0212 16.4784 24.0519 16.5578 24.0772 16.6391C24.1007 16.7204 24.1115 16.7963 24.1079 16.8649C24.1043 16.9335 24.0844 17.0004 24.0465 17.0618C24.0103 17.125 23.9507 17.1954 23.8695 17.2731L23.0982 18.0173L21.7182 16.5867L22.2493 16.0756C22.3269 15.9997 22.3956 15.9546 22.4552 15.9401C22.5148 15.9239 22.5834 15.9275 22.6593 15.951C22.7351 15.9744 22.8345 16.025 22.9519 16.1009L23.1849 15.8769L22.2673 14.925L22.0343 15.149C22.112 15.279 22.1608 15.382 22.1806 15.4579C22.2005 15.5337 22.2005 15.6023 22.1788 15.662C22.1571 15.7234 22.1102 15.7884 22.0379 15.8588L21.5069 16.37L20.2534 15.0695L21.0373 14.3145C21.1023 14.2531 21.1619 14.2043 21.2161 14.1682C21.2703 14.1321 21.3281 14.1104 21.3859 14.1032C21.4437 14.0959 21.5069 14.0996 21.5737 14.1122C21.6424 14.1267 21.7182 14.1519 21.8031 14.1863C21.888 14.2224 21.9837 14.2675 22.0849 14.3253L22.3287 14.0905L21.6062 13.3409L19.2906 15.5771L19.4081 15.6981C19.5038 15.6475 19.576 15.615 19.6248 15.6023Z"
                fill="#040000"
              />
              <path
                d="M22.9916 12.5461C23.0404 12.5407 23.0892 12.5461 23.1325 12.5642C23.1777 12.5823 23.2246 12.6166 23.277 12.669C23.3276 12.7214 23.3998 12.8117 23.4902 12.9417L25.2079 15.3783C25.3054 15.5174 25.3723 15.624 25.4084 15.7016C25.4445 15.7775 25.4553 15.848 25.4409 15.913C25.4264 15.978 25.3723 16.0665 25.2783 16.1785L25.3759 16.3158L26.6113 15.4452L26.5138 15.3061C26.4072 15.3512 26.3241 15.3765 26.2663 15.3856C26.2085 15.3946 26.1525 15.3892 26.1002 15.3675C26.0478 15.3476 25.9918 15.3079 25.934 15.2519C25.8762 15.1941 25.8076 15.111 25.7281 14.999L25.0688 14.0634C25.188 13.9911 25.3524 13.881 25.5619 13.7328C25.748 13.601 25.9105 13.4547 26.0478 13.2921C26.1869 13.1296 26.2826 12.9544 26.3368 12.7683C26.391 12.5823 26.3964 12.3854 26.3548 12.1831C26.3133 11.979 26.223 11.7803 26.0857 11.5852C25.8437 11.242 25.5565 11.0614 25.2223 11.0452C24.8882 11.0289 24.5035 11.1752 24.0627 11.4841L22.6665 12.4685L22.764 12.6058C22.8652 12.5714 22.9429 12.5516 22.9916 12.5461ZM24.1151 11.8182C24.2397 11.7315 24.3626 11.6647 24.4872 11.6177C24.6118 11.5708 24.7346 11.5527 24.8575 11.5654C24.9803 11.578 25.1013 11.6232 25.2205 11.7008C25.3397 11.7785 25.4571 11.8977 25.5709 12.0585C25.7209 12.2698 25.8039 12.4667 25.822 12.6473C25.8401 12.8279 25.7985 12.9941 25.6992 13.1458C25.5998 13.2993 25.4445 13.4493 25.2332 13.5992L24.9062 13.8286L23.7051 12.1253C23.7918 12.053 23.9291 11.9501 24.1151 11.8182Z"
                fill="#040000"
              />
              <path
                d="M26.745 10.0644C26.7956 10.0662 26.8407 10.0807 26.8823 10.1041C26.9238 10.1276 26.9654 10.171 27.0087 10.2306C27.0521 10.2902 27.1081 10.3913 27.1785 10.5322L28.5025 13.2018C28.5783 13.3536 28.6271 13.471 28.6506 13.5504C28.6741 13.6317 28.6741 13.7022 28.6506 13.7636C28.6271 13.825 28.5603 13.9045 28.4483 14.0002L28.5241 14.1519L31.3816 12.734L30.903 11.6214L30.5977 11.7731C30.6266 11.9339 30.6465 12.0567 30.6591 12.1416C30.6718 12.2265 30.6772 12.3114 30.6754 12.3963C30.6736 12.4812 30.6609 12.557 30.6374 12.6202C30.614 12.6853 30.5742 12.7413 30.52 12.79C30.4659 12.8388 30.3882 12.8876 30.287 12.9381L29.3279 13.415L28.4447 11.634L29.1058 11.3071C29.2033 11.2583 29.281 11.2367 29.3424 11.2403C29.4038 11.2421 29.4688 11.2674 29.5338 11.3125C29.6007 11.3577 29.6783 11.4353 29.7686 11.5437L30.0594 11.3992L29.4706 10.2143L29.1798 10.3588C29.2141 10.5051 29.2304 10.6189 29.2268 10.6966C29.2232 10.7743 29.2033 10.8393 29.1636 10.8917C29.1256 10.9422 29.0606 10.991 28.9703 11.0362L28.3092 11.3631L27.5072 9.74651L28.4826 9.26244C28.5621 9.2227 28.6343 9.19381 28.6975 9.17755C28.7608 9.15949 28.8204 9.15587 28.8782 9.16671C28.936 9.17574 28.9938 9.19922 29.0552 9.23354C29.1148 9.26786 29.1816 9.31482 29.2521 9.37443C29.3225 9.43404 29.3984 9.50628 29.4796 9.59298L29.7813 9.44307L29.3189 8.51105L26.4325 9.94339L26.5084 10.0951C26.6168 10.0716 26.6944 10.0626 26.745 10.0644Z"
                fill="#040000"
              />
              <path
                d="M32.2703 11.8345C32.6749 12.1199 33.1554 12.1741 33.7117 11.9971C33.97 11.914 34.203 11.8255 34.4089 11.7298C34.6148 11.6341 34.8135 11.5257 35.0013 11.4047L34.7015 10.4654L34.3764 10.5702C34.3764 10.8086 34.3547 10.9964 34.3114 11.1337C34.2698 11.271 34.1994 11.383 34.1018 11.4697C34.0043 11.5564 33.8652 11.6304 33.6864 11.6882C33.4498 11.7641 33.2258 11.7497 33.0145 11.6485C32.8031 11.5455 32.6081 11.3559 32.4274 11.0795C32.2468 10.8032 32.0897 10.451 31.9524 10.0211C31.8169 9.59481 31.7501 9.21369 31.7555 8.88135C31.7591 8.549 31.826 8.27806 31.9542 8.07215C32.0825 7.86624 32.2595 7.72716 32.4852 7.65491C32.637 7.60614 32.7724 7.58989 32.8953 7.60253C33.0181 7.61698 33.1373 7.66756 33.2547 7.75426C33.3721 7.84095 33.4859 7.971 33.5997 8.1444L33.9248 8.03964L33.634 7.1311C33.3992 7.14375 33.1951 7.16542 33.0199 7.19974C32.8447 7.23225 32.6568 7.28102 32.4582 7.34424C32.059 7.47068 31.7483 7.67659 31.5225 7.96197C31.2967 8.24736 31.1667 8.58874 31.1324 8.98791C31.0981 9.38709 31.1541 9.82059 31.304 10.2902C31.5442 11.0326 31.8657 11.5492 32.2703 11.8345Z"
                fill="#040000"
              />
              <path
                d="M36.8906 8.0992C36.9828 8.23828 37.1146 8.36291 37.2844 8.47309C37.4542 8.58327 37.68 8.68803 37.9617 8.79099C38.2525 8.89756 38.4729 8.99329 38.6174 9.08179C38.7619 9.1703 38.8721 9.26783 38.9461 9.37801C39.0184 9.48819 39.0635 9.62908 39.0834 9.79887C39.1141 10.0662 39.0654 10.2775 38.9371 10.4329C38.8107 10.5882 38.6138 10.6803 38.3465 10.711C38.1532 10.7327 37.9906 10.7219 37.8606 10.6803C37.7305 10.6388 37.6204 10.5629 37.53 10.4563C37.4397 10.348 37.3603 10.1962 37.2916 10.0012L36.9484 10.0391L37.0532 10.9765C37.5355 11.0452 37.9545 11.0596 38.314 11.0199C38.5361 10.9946 38.7366 10.9494 38.9172 10.8808C39.0979 10.8122 39.2496 10.72 39.3706 10.6008C39.4916 10.4816 39.5819 10.3353 39.6379 10.1619C39.6957 9.98852 39.7102 9.7808 39.6831 9.54058C39.6596 9.32563 39.5928 9.1432 39.4844 8.99148C39.376 8.84156 39.2351 8.71151 39.0599 8.60314C38.8847 8.49477 38.6427 8.38458 38.3356 8.2726C38.081 8.18048 37.8859 8.09378 37.7522 8.0125C37.6186 7.93122 37.5156 7.8373 37.4452 7.73073C37.3747 7.62597 37.3296 7.49231 37.3115 7.32974C37.2952 7.17621 37.3133 7.04075 37.3693 6.92334C37.4253 6.80413 37.5084 6.71201 37.6204 6.64337C37.7323 6.57474 37.8624 6.53319 38.0105 6.51694C38.1821 6.49707 38.323 6.50429 38.435 6.53681C38.547 6.56932 38.6499 6.63615 38.742 6.73911C38.8342 6.84206 38.9172 6.99198 38.9931 7.18524L39.3327 7.14731L39.2297 6.22252C38.9732 6.1864 38.7619 6.16833 38.5939 6.16833C38.4259 6.16833 38.2562 6.17917 38.0828 6.19723C37.7829 6.22975 37.5246 6.31103 37.3043 6.44108C37.0839 6.56932 36.925 6.73549 36.8256 6.93598C36.7263 7.13648 36.692 7.36587 36.7209 7.62235C36.7407 7.80298 36.7967 7.96012 36.8906 8.0992Z"
                fill="#040000"
              />
              <path
                d="M40.6657 9.76269C40.6657 10.1366 40.7379 10.4111 40.8824 10.5881C41.0269 10.7652 41.2473 10.8519 41.5435 10.8519C41.6988 10.8519 41.8506 10.8157 41.9969 10.7453C42.1432 10.6748 42.2967 10.5592 42.4611 10.4003L42.3057 10.2143C42.2281 10.2847 42.1486 10.3407 42.0673 10.3786C41.986 10.4166 41.9011 10.4346 41.809 10.4346C41.7079 10.4346 41.6248 10.4184 41.5616 10.3858C41.4965 10.3533 41.4405 10.301 41.39 10.2251C41.3394 10.151 41.3051 10.0463 41.287 9.91442C41.269 9.78256 41.2599 9.60555 41.2599 9.38158V7.84808H42.3726V7.49948H41.2599V6.64874H40.7704C40.7451 6.85827 40.7217 7.01721 40.6982 7.12559C40.6747 7.23396 40.644 7.32608 40.6025 7.39833C40.5627 7.47058 40.5067 7.53019 40.4345 7.57534C40.3622 7.6205 40.2701 7.65301 40.1563 7.67107V7.84628H40.6657V9.76269Z"
                fill="#040000"
              />
              <path
                d="M42.9722 10.7904C43.0969 10.8735 43.2468 10.9241 43.4202 10.9422C43.6171 10.9638 43.8067 10.9422 43.991 10.8771C44.1752 10.8121 44.3775 10.6893 44.5997 10.5087L44.6502 10.5285L44.578 11.0162L45.5154 11.121L45.5335 10.953C45.436 10.9151 45.3673 10.8808 45.3258 10.8501C45.2842 10.8193 45.2535 10.7868 45.2355 10.7471C45.2174 10.7092 45.2048 10.6604 45.1993 10.599C45.1939 10.5376 45.1957 10.4725 45.2011 10.4039C45.2066 10.3353 45.2192 10.2143 45.2373 10.0463L45.3709 8.85416C45.4052 8.55433 45.3944 8.32674 45.3438 8.17141C45.2933 8.01607 45.2011 7.89325 45.0729 7.80655C44.9447 7.71985 44.7658 7.66386 44.5401 7.63676C44.3901 7.62051 44.2384 7.6187 44.0903 7.63315C43.9404 7.6476 43.7905 7.67289 43.6387 7.71082C43.487 7.74875 43.2938 7.81197 43.0626 7.90047L43.012 8.34481L43.4599 8.39538C43.5358 8.21476 43.6333 8.0829 43.7525 8.00162C43.8717 7.92034 44.0199 7.88964 44.1987 7.9095C44.363 7.92757 44.4913 7.97453 44.5816 8.04858C44.6719 8.12445 44.7333 8.23282 44.764 8.37371C44.7947 8.5164 44.7965 8.70605 44.7695 8.94267L44.7442 9.16484C44.0813 9.12149 43.5737 9.17026 43.2251 9.31475C42.8747 9.45925 42.6814 9.69768 42.6435 10.0318C42.6254 10.1908 42.6453 10.3371 42.7031 10.4671C42.7555 10.6026 42.8458 10.7074 42.9722 10.7904ZM43.2414 10.0174C43.2685 9.77715 43.4039 9.61098 43.6478 9.51886C43.8916 9.42674 44.2456 9.40326 44.7098 9.45022L44.6557 9.93249C44.643 10.0463 44.5942 10.1583 44.5112 10.2666C44.4281 10.375 44.3179 10.4599 44.1824 10.5213C44.047 10.5827 43.9025 10.6044 43.7471 10.5863C43.6369 10.5737 43.5448 10.5484 43.4672 10.5123C43.3913 10.4744 43.3299 10.4148 43.2865 10.3335C43.2414 10.254 43.2269 10.1474 43.2414 10.0174Z"
                fill="#040000"
              />
              <path
                d="M47.2115 11.3504C47.1049 11.2926 47.0327 11.2384 46.9929 11.1861C46.9532 11.1337 46.9333 11.0687 46.9351 10.9892C46.9369 10.9097 46.9622 10.7742 47.011 10.5828L47.3307 9.33828C47.3578 9.23171 47.403 9.14321 47.4662 9.07096C47.5294 8.99871 47.6197 8.93368 47.7335 8.87227C47.8491 8.81267 47.9502 8.77473 48.0369 8.76028C48.1236 8.74584 48.2103 8.74945 48.297 8.77293C48.3837 8.7946 48.4506 8.8235 48.4993 8.85602C48.5481 8.88853 48.5878 8.92646 48.6222 8.96981C48.6547 9.01316 48.68 9.06012 48.698 9.11431C48.7161 9.16849 48.7251 9.23713 48.7269 9.32383C48.7269 9.41053 48.7161 9.5189 48.6926 9.64715C48.6691 9.77539 48.6366 9.91808 48.5969 10.0734L48.3729 10.9476C48.335 11.0994 48.297 11.2095 48.2645 11.28C48.2302 11.3504 48.1959 11.401 48.1616 11.4299C48.1273 11.4588 48.0875 11.4787 48.0442 11.4895C48.0008 11.5003 47.9322 11.5076 47.8401 11.5112L47.7985 11.6755L49.1135 12.0133L49.155 11.8508C49.0575 11.7948 48.9906 11.7496 48.9563 11.7117C48.9202 11.6755 48.8967 11.6358 48.8841 11.5925C48.8714 11.5491 48.8696 11.4913 48.8787 11.4209C48.8877 11.3504 48.9112 11.2366 48.9509 11.0831L49.2742 9.82416C49.3212 9.63992 49.3501 9.48459 49.3573 9.35815C49.3645 9.23171 49.3555 9.11973 49.332 9.02219C49.3067 8.92465 49.2652 8.83795 49.2092 8.76028C49.1514 8.68442 49.0791 8.6194 48.9924 8.56702C48.9057 8.51464 48.801 8.47309 48.6818 8.44239C48.5662 8.41349 48.4524 8.40446 48.3386 8.4171C48.2248 8.42974 48.1092 8.45864 47.99 8.5038C47.8708 8.54896 47.7064 8.63385 47.4987 8.75848L47.4553 8.73319L47.6323 8.19855L47.4282 8.14617L46.6389 7.97638L46.5938 8.15339C46.6895 8.19674 46.7617 8.23828 46.8087 8.27802C46.8575 8.31776 46.8864 8.36653 46.9008 8.42613C46.9135 8.48574 46.9117 8.55799 46.8936 8.64649C46.8755 8.735 46.8484 8.84879 46.8123 8.99148L46.4384 10.4455C46.3987 10.6008 46.3626 10.7146 46.3282 10.7833C46.2957 10.8537 46.2614 10.9025 46.2271 10.9314C46.1928 10.9603 46.1548 10.9801 46.1115 10.991C46.0699 11.0018 46.0013 11.009 45.9092 11.0127L45.8676 11.177L47.1754 11.513L47.2115 11.3504Z"
                fill="#040000"
              />
              <path
                d="M50.5801 12.669C50.7065 12.7232 50.8348 12.7521 50.9648 12.7557C51.0931 12.7612 51.2213 12.7485 51.3514 12.7178C51.4796 12.6889 51.6404 12.6311 51.8336 12.5462L51.8752 12.5787L51.6169 13.0827L51.8066 13.164L52.5688 13.4493L52.6392 13.285C52.5345 13.2127 52.4658 13.1549 52.4315 13.1098C52.3972 13.0646 52.3791 13.0158 52.3755 12.9653C52.3719 12.9147 52.3827 12.8515 52.4062 12.7774C52.4297 12.7034 52.4767 12.5842 52.5471 12.4198L54.0987 8.74409L53.9108 8.66462L53.1287 8.37201L53.0583 8.53638C53.1576 8.6014 53.2244 8.65198 53.2588 8.6881C53.2931 8.72423 53.3148 8.76396 53.3256 8.80551C53.3364 8.84705 53.3364 8.89943 53.3274 8.96084C53.3184 9.02225 53.2967 9.0945 53.266 9.17578C53.2353 9.25706 53.1775 9.39976 53.0908 9.60386L52.8777 10.1078C52.7783 10.0067 52.6772 9.91995 52.5706 9.84951C52.4658 9.77907 52.343 9.71404 52.2039 9.65444C51.9438 9.54426 51.6837 9.50452 51.4254 9.53523C51.1671 9.56593 50.9251 9.67611 50.6993 9.86577C50.4735 10.0554 50.2893 10.3246 50.1412 10.6713C49.9317 11.1681 49.8648 11.5889 49.9425 11.9321C50.022 12.2771 50.2333 12.5227 50.5801 12.669ZM50.7788 10.8375C50.9504 10.4311 51.1527 10.1493 51.3857 9.9922C51.6187 9.83506 51.8716 9.81339 52.1425 9.92898C52.2419 9.97053 52.3231 10.0175 52.3845 10.0681C52.446 10.1186 52.4965 10.1801 52.5363 10.2523C52.576 10.3246 52.5995 10.4004 52.6049 10.4835C52.6121 10.5666 52.6013 10.6605 52.5742 10.7653C52.5471 10.87 52.4983 11.0055 52.4297 11.1717L52.1299 11.8815C52.0865 11.9863 52.0432 12.0676 51.9998 12.1254C51.9565 12.185 51.9113 12.2337 51.8607 12.2717C51.8102 12.3096 51.7415 12.3475 51.6548 12.3837C51.5681 12.4198 51.4868 12.4415 51.4128 12.4523C51.3387 12.4613 51.2683 12.4613 51.1997 12.4523C51.131 12.4415 51.0515 12.418 50.9576 12.3782C50.721 12.2789 50.5891 12.0983 50.562 11.8364C50.535 11.5781 50.6072 11.2439 50.7788 10.8375Z"
                fill="#040000"
              />
              <path
                d="M55.1029 11.578C55.2456 11.5527 55.3937 11.5871 55.5472 11.6792C55.6899 11.7641 55.7856 11.8598 55.838 11.9646C55.8904 12.0711 55.8994 12.194 55.8687 12.3366C55.838 12.4793 55.7604 12.6527 55.6375 12.8568L55.5237 13.0501C54.9385 12.7358 54.4563 12.5715 54.0769 12.5588C53.6976 12.5462 53.4231 12.6834 53.2515 12.9706C53.1684 13.1097 53.1269 13.2488 53.1251 13.3915C53.1233 13.5342 53.163 13.6678 53.2425 13.7943C53.3219 13.9207 53.4375 14.0291 53.5875 14.1176C53.7572 14.2187 53.9397 14.2783 54.1329 14.2946C54.328 14.3109 54.5628 14.2838 54.8392 14.2097L54.8771 14.2476L54.6098 14.6613L55.4208 15.1453L55.5075 15.0008C55.4352 14.925 55.3865 14.8654 55.3594 14.8202C55.3341 14.7751 55.3196 14.7317 55.3196 14.6902C55.3178 14.6486 55.3269 14.5981 55.3485 14.5403C55.3684 14.4825 55.3955 14.4247 55.4298 14.3632C55.4641 14.3018 55.5237 14.1989 55.6104 14.0526L56.2246 13.023C56.3781 12.7647 56.4648 12.5534 56.481 12.3908C56.4973 12.2265 56.4666 12.0784 56.3853 11.9465C56.304 11.8146 56.1668 11.69 55.9699 11.5726C55.8398 11.4949 55.7044 11.4317 55.5617 11.383C55.419 11.3342 55.2709 11.2963 55.1173 11.2674C54.9638 11.2385 54.7633 11.2168 54.5141 11.2023L54.2847 11.5871L54.673 11.8183C54.8193 11.6828 54.962 11.6033 55.1029 11.578ZM55.13 13.7076C55.0704 13.8069 54.9819 13.8882 54.8609 13.9514C54.7398 14.0146 54.6044 14.0471 54.4563 14.0471C54.3081 14.0471 54.1673 14.0074 54.0318 13.9261C53.9379 13.8701 53.862 13.8087 53.8078 13.7419C53.7536 13.6769 53.7229 13.5974 53.7157 13.5053C53.7085 13.4132 53.7392 13.3102 53.806 13.1982C53.9288 12.9905 54.1221 12.8948 54.3822 12.911C54.6423 12.9273 54.9746 13.0537 55.3774 13.2885L55.13 13.7076Z"
                fill="#040000"
              />
              <path
                d="M56.3058 15.2032C56.248 15.2537 56.1974 15.2863 56.1541 15.2989C56.1107 15.3115 56.0656 15.3134 56.024 15.3079C55.9807 15.3007 55.9175 15.2826 55.8308 15.2501L55.7278 15.3838L56.826 16.2327L56.929 16.0991C56.8495 16.0106 56.7971 15.9347 56.7736 15.8697C56.7501 15.8047 56.7519 15.7324 56.7808 15.6547C56.8097 15.5771 56.8874 15.4542 57.0157 15.2899L57.7526 14.3362C57.8194 14.2495 57.8899 14.1827 57.9621 14.1357C58.0344 14.0905 58.1283 14.0526 58.2439 14.0273C58.3595 14.0002 58.4661 13.993 58.56 14.0056C58.6539 14.0165 58.7334 14.049 58.7984 14.0996C58.8833 14.1664 58.9339 14.2405 58.9483 14.3217C58.9628 14.4048 58.9537 14.5114 58.923 14.6432L59.2319 14.8817L59.716 14.2549C59.6383 14.1772 59.548 14.0996 59.4414 14.0183C59.3168 13.9207 59.1886 13.8539 59.0603 13.816C58.9321 13.7781 58.7984 13.76 58.6575 13.7636C58.5184 13.7672 58.3505 13.7925 58.1572 13.8359L58.1247 13.7979L58.5239 13.3446L58.3577 13.2163L57.6984 12.7503L57.5882 12.8912C57.6587 12.9689 57.7074 13.0357 57.7363 13.0899C57.7652 13.1459 57.7725 13.2019 57.7616 13.2615C57.7508 13.3211 57.7201 13.3879 57.6677 13.462C57.6171 13.536 57.5467 13.6299 57.4564 13.7473L56.5388 14.9359C56.4413 15.0623 56.3618 15.1508 56.3058 15.2032Z"
                fill="#040000"
              />
              <path
                d="M58.3343 16.9732C58.2783 17.32 58.383 17.6271 58.6504 17.8926C58.7479 17.9902 58.8563 18.0642 58.9737 18.1166C59.0911 18.169 59.2157 18.2051 59.3458 18.2268C59.4758 18.2485 59.6456 18.2539 59.8569 18.2466L59.884 18.2936L59.4559 18.6657L59.6022 18.812L60.2037 19.3611L60.3302 19.2347C60.2597 19.1299 60.2182 19.0486 60.2019 18.9944C60.1875 18.9402 60.1875 18.8879 60.2037 18.8391C60.22 18.7903 60.2525 18.7361 60.3013 18.6765C60.35 18.6169 60.4385 18.523 60.565 18.3966L63.3773 15.568L63.2328 15.4253L62.6168 14.8618L62.4904 14.9882C62.559 15.0857 62.6024 15.1562 62.6187 15.2031C62.6349 15.2501 62.6421 15.2934 62.6367 15.3368C62.6313 15.3801 62.6114 15.4289 62.5807 15.4813C62.5482 15.5355 62.5031 15.5933 62.4434 15.6583C62.3838 15.7233 62.2773 15.8335 62.1219 15.9888L61.7354 16.3772C61.6812 16.2453 61.6198 16.1279 61.5476 16.0232C61.4771 15.9184 61.3868 15.8136 61.2802 15.7053C61.0797 15.5066 60.854 15.3729 60.6029 15.3043C60.3518 15.2356 60.0863 15.2483 59.8063 15.3404C59.5264 15.4325 59.2536 15.6131 58.9881 15.8805C58.6088 16.2616 58.3903 16.6264 58.3343 16.9732ZM60.3952 15.7089C60.6697 15.6511 60.9118 15.7251 61.1213 15.9329C61.1971 16.0087 61.2549 16.0828 61.2929 16.1532C61.3308 16.2237 61.3561 16.2995 61.3651 16.3808C61.376 16.4621 61.3669 16.5416 61.3434 16.621C61.3182 16.7005 61.273 16.7836 61.2098 16.8703C61.1448 16.9588 61.049 17.0654 60.9226 17.1936L60.3789 17.7409C60.2994 17.8204 60.229 17.88 60.1676 17.9197C60.1062 17.9595 60.0448 17.9865 59.9834 18.0046C59.9219 18.0227 59.8443 18.0299 59.7503 18.0317C59.6564 18.0317 59.5733 18.0227 59.5011 18.0046C59.4288 17.9865 59.3638 17.9595 59.3042 17.9251C59.2446 17.8908 59.1796 17.8384 59.1073 17.7662C58.9249 17.5856 58.8707 17.3688 58.943 17.1159C59.0152 16.8631 59.2067 16.5813 59.5173 16.2688C59.828 15.9563 60.1206 15.7685 60.3952 15.7089Z"
                fill="#040000"
              />
              <path
                d="M39.9991 0C17.9088 0 0 17.9088 0 39.9991C0 62.0894 17.9088 79.9982 39.9991 79.9982C62.0894 79.9982 79.9982 62.0894 79.9982 39.9991C79.9982 17.9088 62.0912 0 39.9991 0ZM39.9991 77.4984C19.2888 77.4984 2.49983 60.7094 2.49983 39.9991C2.49983 19.2888 19.2888 2.49983 39.9991 2.49983C60.7094 2.49983 77.4984 19.2888 77.4984 39.9991C77.4984 60.7094 60.7094 77.4984 39.9991 77.4984Z"
                fill="#51ACE0"
              />
              <path
                d="M37.9887 34.2047C37.2211 32.2485 34.9976 31.2894 33.0414 32.0571C31.0853 32.8247 30.1261 35.0482 30.8938 37.0043C31.6615 38.9605 33.8849 39.9196 35.8411 39.152C37.7972 38.3843 38.7564 36.1608 37.9887 34.2047Z"
                fill="#51ACE0"
              />
              <path
                d="M50.7589 40.149C49.341 40.1111 48.1127 41.2219 48.0748 42.6795C48.0369 44.0992 49.1477 45.3257 50.6053 45.3636C52.063 45.4015 53.2894 44.251 53.2894 42.8331C53.3273 41.4134 52.2165 40.1869 50.7589 40.149Z"
                fill="#51ACE0"
              />
              <path
                d="M41.2111 47.5871C40.2899 47.5492 39.562 48.2392 39.5241 49.1585C39.4861 50.0779 40.214 50.8076 41.0955 50.8456C42.0167 50.8835 42.7446 50.1556 42.7825 49.2741C42.8204 48.3548 42.0925 47.6251 41.2111 47.5871Z"
                fill="#51ACE0"
              />
              <path
                d="M40.7378 15.1561C26.9815 15.1561 15.8298 26.3078 15.8298 40.0641C15.8298 53.8204 26.9815 64.9721 40.7378 64.9721C54.4941 64.9721 65.6458 53.8204 65.6458 40.0641C65.6458 26.3078 54.4941 15.1561 40.7378 15.1561ZM36.1861 44.7495L35.917 44.0975C35.7635 43.7145 35.3805 43.4833 34.9579 43.5231C34.537 43.5231 34.1144 43.5231 33.6917 43.4851C33.2708 43.4472 32.8861 43.6387 32.6947 44.0216L32.3876 44.6736C32.1582 45.1342 31.582 45.3257 31.1214 45.1342L29.6638 44.5201C29.2032 44.3286 28.9738 43.7922 29.1653 43.2937L29.4344 42.6416C29.5879 42.2587 29.4723 41.836 29.1653 41.5687C28.8582 41.2996 28.5512 40.9943 28.2838 40.6475C28.0147 40.3405 27.5938 40.1869 27.2109 40.3405L26.5209 40.5699C26.0224 40.7234 25.486 40.494 25.2945 39.9955L25.0254 39.2676L24.7563 38.5397C24.5648 38.0791 24.7942 37.5047 25.2548 37.3132L25.9068 37.0441C26.2897 36.8906 26.5209 36.5076 26.4812 36.085C26.4812 35.6641 26.4812 35.2415 26.5191 34.8188C26.5571 34.398 26.3656 34.0132 25.9827 33.8218L25.3306 33.5147C24.87 33.2853 24.6786 32.7091 24.87 32.2485L25.1771 31.5206L25.4842 30.7927C25.6756 30.3321 26.2121 30.1027 26.7106 30.2942L27.4385 30.5633C27.8214 30.7169 28.2441 30.6013 28.5114 30.2942C28.7805 29.9871 29.0858 29.6801 29.4308 29.4127C29.7379 29.1436 29.8914 28.7228 29.7379 28.3398L29.5085 27.6499C29.3549 27.1513 29.5843 26.6149 30.0828 26.4234L31.5405 25.887C32.0011 25.6955 32.5754 25.9249 32.7669 26.3855L33.036 27.0375C33.1896 27.4205 33.5725 27.6517 33.9952 27.6119C34.4178 27.6119 34.8387 27.6119 35.2613 27.6499C35.684 27.6878 36.0669 27.4963 36.2584 27.1134L36.5654 26.4614C36.7948 26.0008 37.371 25.8093 37.8316 26.0008L38.5595 26.3458L39.2874 26.6528C39.748 26.8443 39.9774 27.3807 39.7859 27.8793L39.5168 28.5313C39.3633 28.9142 39.4789 29.3369 39.7859 29.6042C40.093 29.8733 40.4001 30.1786 40.6674 30.5254C40.9365 30.8325 41.3574 30.986 41.7403 30.8325L42.4303 30.6031C42.9288 30.4495 43.4652 30.6789 43.5808 31.1395L43.85 31.8674L44.1191 32.5953C44.3106 33.0559 44.0812 33.6303 43.6206 33.8218L42.9685 34.0909C42.5856 34.2444 42.3544 34.6274 42.3941 35.05C42.3941 35.4727 42.3941 35.8935 42.3562 36.3162C42.3183 36.737 42.5097 37.1218 42.8927 37.3132L43.5447 37.6203C44.0053 37.8497 44.1968 38.4259 44.0053 38.8865L43.3912 40.3441C43.1997 40.8047 42.6633 41.0341 42.1648 40.8426L41.5127 40.5735C41.1298 40.42 40.7071 40.5356 40.4398 40.8426C40.1707 41.1497 39.8654 41.4567 39.5186 41.7241C39.2116 41.9932 39.058 42.414 39.2116 42.797L39.441 43.4869C39.5945 43.9855 39.3651 44.5219 38.8666 44.7134L38.1387 44.9825L37.4107 45.2516C36.9538 45.4395 36.3776 45.2101 36.1861 44.7495ZM45.4666 49.0068V49.6968C45.4666 49.9262 45.2751 50.1176 45.0457 50.1176H44.7386C44.5851 50.1176 44.4316 50.2332 44.3557 50.3868C44.2799 50.5782 44.2022 50.7318 44.1263 50.8853C44.0505 51.0388 44.0505 51.2303 44.1643 51.3459L44.3557 51.5753C44.5093 51.7288 44.4713 51.9979 44.3178 52.1497L43.8572 52.6102C43.7037 52.7638 43.4345 52.7638 43.2828 52.6102L43.0534 52.3808C42.9378 52.2653 42.7464 52.2273 42.5928 52.305C42.4393 52.3808 42.2858 52.4585 42.0943 52.4965C41.9408 52.5723 41.7873 52.6879 41.7873 52.8794L41.7493 53.1864C41.7493 53.4158 41.5579 53.5694 41.3267 53.5694H40.6367C40.4073 53.5694 40.214 53.3779 40.214 53.1467V52.8396C40.214 52.6861 40.0984 52.5326 39.9449 52.4567C39.7534 52.3809 39.5999 52.3032 39.4464 52.2273C39.2928 52.1515 39.1014 52.1515 38.9858 52.2652L38.7564 52.4567C38.6029 52.6102 38.3355 52.5723 38.182 52.4188L37.7214 51.9582C37.5679 51.8047 37.5679 51.5373 37.7214 51.3838L37.9508 51.1544C38.0664 51.0388 38.1043 50.8474 38.0267 50.6938C37.9508 50.5403 37.8731 50.3868 37.8352 50.1953C37.7593 50.0418 37.6437 49.8882 37.4523 49.8882L37.1452 49.8503C36.9158 49.8503 36.7623 49.6589 36.7623 49.4295V48.7395C36.7623 48.5101 36.9538 48.3186 37.1832 48.3186H37.4902C37.6437 48.3186 37.7973 48.203 37.8731 48.0495C37.949 47.858 38.0267 47.7045 38.1025 47.551C38.1784 47.3974 38.1784 47.206 38.0646 47.0904L37.8731 46.861C37.7196 46.7075 37.7575 46.4401 37.9111 46.2866L38.1802 46.0572L38.4096 45.8278C38.5631 45.6743 38.8323 45.6743 38.984 45.8278L39.2134 46.0572C39.329 46.1728 39.5204 46.2107 39.674 46.1331C39.8275 46.0572 39.981 45.9795 40.1725 45.9416C40.326 45.8658 40.4795 45.7502 40.4795 45.5587L40.5175 45.2516C40.5175 45.0222 40.7089 44.8687 40.9401 44.8687H41.6301C41.8595 44.8687 42.051 45.0602 42.051 45.2914V45.5984C42.051 45.752 42.1666 45.9055 42.3201 45.9814C42.5116 46.0572 42.6651 46.1349 42.8186 46.2107C42.9721 46.2866 43.1636 46.2866 43.2792 46.1728L43.5086 45.9814C43.6621 45.8278 43.9294 45.8658 44.083 46.0193L44.5436 46.4799C44.6971 46.6334 44.6971 46.9007 44.5436 47.0543L44.3142 47.2836C44.1986 47.3993 44.1606 47.5907 44.2365 47.7442C44.3142 47.8978 44.39 48.0513 44.428 48.2428C44.5038 48.3963 44.6194 48.5498 44.8109 48.5498L45.118 48.5878C45.351 48.5841 45.5045 48.7756 45.4666 49.0068ZM57.6984 43.4851C57.6984 43.8301 57.3913 44.1372 57.0463 44.1372H56.5478C56.2787 44.1372 56.0114 44.3286 55.9337 44.5978C55.8578 44.8669 55.7422 45.1342 55.5887 45.4034C55.4352 45.6327 55.4731 45.9398 55.6646 46.171L55.9716 46.5539C56.201 46.8231 56.201 47.2439 55.9337 47.4733L55.5508 47.8562L55.1678 48.2392C54.8987 48.5083 54.5158 48.5083 54.2485 48.2392L53.9035 47.8942C53.712 47.7027 53.405 47.6648 53.1358 47.7786C52.9064 47.8942 52.5994 48.0079 52.3303 48.0856C52.0611 48.2012 51.8697 48.4306 51.8317 48.6997L51.7938 49.1983C51.7559 49.5433 51.4488 49.8124 51.1038 49.8124H50.0309C49.6859 49.8124 49.3789 49.5053 49.3789 49.1603V48.6618C49.3789 48.3927 49.1874 48.1254 48.9183 48.0477C48.6491 47.9718 48.3818 47.8562 48.1127 47.7027C47.8833 47.5492 47.5762 47.5871 47.345 47.7786L46.9621 48.0856C46.693 48.315 46.2721 48.315 46.0409 48.0477L45.658 47.6648L45.2751 47.2818C45.006 47.0127 45.006 46.6298 45.2751 46.3607L45.6201 46.0157C45.8115 45.8242 45.8495 45.5172 45.7357 45.248C45.6201 45.0186 45.5063 44.7116 45.4286 44.4424C45.313 44.1733 45.0836 43.9818 44.8145 43.9439L44.316 43.906C43.971 43.8681 43.7019 43.561 43.7019 43.216V42.1431C43.7019 41.7981 44.0089 41.4911 44.3539 41.4911H44.8524C45.1216 41.4911 45.3889 41.2996 45.4666 41.0305C45.5424 40.7613 45.658 40.494 45.8115 40.2249C45.9651 39.9955 45.9271 39.6884 45.7339 39.4572L45.4268 39.0743C45.1974 38.8052 45.1974 38.3843 45.4648 38.1549L45.8477 37.772L46.2306 37.3891C46.4997 37.12 46.8826 37.12 47.1518 37.3891L47.4968 37.7341C47.6882 37.9255 47.9953 37.9635 48.2644 37.8497C48.4938 37.7341 48.8009 37.6203 49.07 37.5426C49.3391 37.427 49.5306 37.1976 49.5685 36.9285L49.6064 36.43C49.6444 36.085 49.9514 35.8159 50.2964 35.8159H51.3693C51.7143 35.8159 52.0214 36.1229 52.0214 36.4679V36.9664C52.0214 37.2356 52.2128 37.5029 52.482 37.5805C52.7511 37.6564 53.0184 37.772 53.2876 37.9255C53.5169 38.0791 53.824 38.0411 54.0552 37.8497L54.4381 37.5426C54.7073 37.3132 55.1281 37.3132 55.3593 37.5805L56.127 38.3482C56.3961 38.6173 56.3961 39.0002 56.127 39.2676L55.782 39.6126C55.5905 39.804 55.5526 40.1111 55.6664 40.3802C55.782 40.6096 55.8958 40.9167 55.9734 41.1858C56.089 41.4549 56.3184 41.6464 56.5876 41.6843L57.0861 41.7222C57.4311 41.7222 57.7002 42.0293 57.7002 42.4122V43.4851H57.6984Z"
                fill="#51ACE0"
              />
            </svg>
          </div>
          <div>
            <div>产品质量评价</div>
            <div
              v-if="!info.showProductGrade"
              class="btn-80-30"
              @click="
                jump(
                  easySeries +
                    '/ecmall/creditRating/getEvaluateList.do?isBreadcrumb=1&supplierType=101'
                )
              "
            >
              申 请
            </div>
            <div v-else>产品等级：{{ info.productGrade }}</div>
          </div>
        </div>
        <div :class="{ 'not-support': !info.gradeId }">
          <div>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M80 39.9991C80 17.9088 62.0912 0 39.9991 0C17.907 0 0 17.9088 0 39.9991C0 62.0894 17.9088 79.9982 39.9991 79.9982C62.0894 79.9982 80 62.0912 80 39.9991ZM39.9991 77.4984C19.2888 77.4984 2.49983 60.7094 2.49983 39.9991C2.49983 19.2888 19.2888 2.49983 39.9991 2.49983C60.7094 2.49983 77.4984 19.2888 77.4984 39.9991C77.4984 60.7094 60.7094 77.4984 39.9991 77.4984Z"
                fill="#51ACE0"
              />
              <path
                d="M32.4147 66.7062C32.5321 66.773 32.6134 66.8272 32.6586 66.8687C32.7037 66.9103 32.7362 66.9591 32.7561 67.015C32.776 67.071 32.7814 67.1433 32.7742 67.2336C32.7669 67.3239 32.7398 67.463 32.6929 67.6526L31.8241 71.2091C31.7735 71.4114 31.7283 71.5595 31.6868 71.6553C31.6453 71.7492 31.5893 71.816 31.517 71.8558C31.4466 71.8955 31.3201 71.9154 31.1395 71.919L31.0907 72.1213L34.8983 73.0515L35.33 71.6282L34.9236 71.5288C34.8224 71.7022 34.7448 71.8341 34.6906 71.9226C34.6346 72.0129 34.5732 72.096 34.5045 72.1755C34.4359 72.2549 34.3636 72.3145 34.2896 72.3561C34.2155 72.3976 34.1342 72.4193 34.0439 72.4229C33.9536 72.4247 33.8434 72.4103 33.708 72.3778L32.4292 72.0653L33.009 69.6919L33.8886 69.9068C34.0168 69.9375 34.109 69.9791 34.165 70.0315C34.2209 70.0838 34.2607 70.1561 34.2878 70.2518C34.3131 70.3475 34.3257 70.4812 34.3239 70.6546L34.7104 70.7485L35.097 69.1699L34.7104 69.076C34.6255 69.2403 34.5515 69.3595 34.4865 69.43C34.4214 69.5004 34.3492 69.5456 34.2733 69.5636C34.1957 69.5817 34.0981 69.5745 33.9771 69.5456L33.0975 69.3306L33.6249 67.1758L34.9236 67.4937C35.0301 67.519 35.1205 67.5497 35.1945 67.584C35.2668 67.6183 35.3264 67.6617 35.3733 67.7177C35.4203 67.7719 35.4582 67.8405 35.4871 67.92C35.5178 67.9994 35.5413 68.0952 35.5612 68.209C35.5792 68.321 35.5937 68.4492 35.6027 68.5937L36.0055 68.693L36.309 67.4503L32.4635 66.5111L32.4147 66.7062Z"
                fill="#040000"
              />
              <path
                d="M42.591 68.4726C42.358 68.2432 42.0708 68.0698 41.7312 67.9506C41.3917 67.8332 40.9546 67.7718 40.4217 67.7699L38.5667 67.7645V67.9722C38.6986 68.0102 38.7925 68.0427 38.8449 68.0716C38.8991 68.1023 38.9406 68.1402 38.9731 68.189C39.0056 68.2378 39.0291 68.3064 39.0418 68.3949C39.0562 68.4834 39.0616 68.6279 39.0616 68.8248L39.049 72.486C39.049 72.6811 39.0418 72.8238 39.0273 72.9141C39.0129 73.0044 38.9894 73.0731 38.9587 73.1218C38.928 73.1706 38.8828 73.2085 38.8268 73.2393C38.7708 73.27 38.6769 73.3025 38.5469 73.335V73.5427L40.0785 73.5481C40.55 73.5499 40.9275 73.5264 41.2129 73.4795C41.4982 73.4325 41.7493 73.353 41.9679 73.2411C42.2316 73.1038 42.4537 72.9286 42.6344 72.7136C42.8439 72.468 43.0028 72.1645 43.113 71.8033C43.2232 71.4402 43.2792 71.0212 43.2792 70.5443C43.281 70.0729 43.225 69.6665 43.1094 69.3269C42.9992 68.9855 42.824 68.702 42.591 68.4726ZM42.3634 71.4041C42.3273 71.6443 42.2713 71.8611 42.1936 72.058C42.1178 72.253 42.0166 72.4264 41.8956 72.5782C41.7746 72.7281 41.6373 72.8455 41.4838 72.9304C41.3303 73.0135 41.1623 73.0767 40.9744 73.1146C40.7884 73.1526 40.5753 73.1724 40.3386 73.1724C40.1183 73.1724 39.9521 73.1652 39.8383 73.1544L39.8546 68.1547C40.0262 68.1438 40.2086 68.1384 40.4001 68.1402C40.8173 68.142 41.1767 68.2269 41.4766 68.3985C41.7764 68.5683 42.0076 68.8374 42.172 69.2077C42.3363 69.5762 42.4176 70.0476 42.414 70.6202C42.4176 70.902 42.3996 71.1657 42.3634 71.4041Z"
                fill="#040000"
              />
              <path
                d="M49.1079 67.0204C48.7359 66.8488 48.2283 66.8398 47.5853 66.9915L45.5424 67.4738L45.5894 67.6761C45.7249 67.6815 45.8206 67.6923 45.8802 67.7104C45.9398 67.7266 45.9904 67.7555 46.0337 67.7953C46.0771 67.835 46.115 67.8982 46.1493 67.9813C46.1836 68.0644 46.2234 68.1999 46.2685 68.3913L47.1102 71.955C47.159 72.1573 47.1843 72.3109 47.1897 72.4138C47.1951 72.5168 47.1753 72.6017 47.1301 72.6685C47.085 72.7353 46.982 72.8112 46.8231 72.8961L46.87 73.0984L48.6781 72.6721L48.6311 72.4698C48.4884 72.4716 48.3836 72.4644 48.3132 72.4463C48.2428 72.4301 48.1813 72.3976 48.1308 72.3506C48.0802 72.3036 48.035 72.2332 47.9953 72.1411C47.9538 72.049 47.9158 71.9225 47.8779 71.76L47.5546 70.3926C47.7244 70.3637 47.9628 70.3132 48.268 70.2409C48.539 70.1777 48.7918 70.0838 49.0248 69.9627C49.2579 69.8417 49.4475 69.6864 49.5938 69.4985C49.7401 69.3107 49.8358 69.0903 49.881 68.8393C49.9262 68.5882 49.9153 68.3191 49.8467 68.0337C49.7275 67.5297 49.4818 67.192 49.1079 67.0204ZM49.0592 69.121C48.9959 69.3342 48.8731 69.5058 48.6907 69.634C48.5083 69.7623 48.2608 69.8634 47.9519 69.9375L47.4733 70.0495L46.8845 67.5568C47.0199 67.5135 47.2222 67.4593 47.495 67.3961C47.6756 67.3527 47.849 67.3329 48.0116 67.3365C48.1741 67.3401 48.324 67.3762 48.4577 67.4467C48.5914 67.5171 48.7088 67.6237 48.8099 67.7664C48.9111 67.9091 48.9887 68.0987 49.0447 68.3353C49.1152 68.646 49.1206 68.9079 49.0592 69.121Z"
                fill="#040000"
              />
              <path
                d="M19.6265 15.6041C19.6753 15.5914 19.7223 15.5896 19.7692 15.6005C19.8162 15.6113 19.8686 15.6384 19.9282 15.6835C19.986 15.7269 20.0709 15.8064 20.181 15.9202L22.2492 18.066C22.3666 18.1888 22.4497 18.2845 22.4966 18.355C22.5436 18.4254 22.5653 18.4922 22.5617 18.5591C22.558 18.6241 22.5183 18.7198 22.4406 18.8463L22.558 18.9673L24.8538 16.7528L24.0608 15.8371L23.8152 16.0737C23.891 16.2182 23.947 16.3284 23.985 16.406C24.0229 16.4837 24.0536 16.5632 24.0789 16.6445C24.1024 16.7257 24.1132 16.8016 24.1096 16.8702C24.106 16.9389 24.0861 17.0057 24.0482 17.0671C24.0103 17.1303 23.9525 17.2008 23.8712 17.2785L23.0999 18.0226L21.7199 16.5921L22.251 16.0809C22.3286 16.0051 22.3973 15.9599 22.4569 15.9454C22.5165 15.9292 22.5851 15.9328 22.661 15.9563C22.7369 15.9798 22.8362 16.0303 22.9536 16.1062L23.1866 15.8804L22.269 14.9285L22.036 15.1489C22.1137 15.2789 22.1625 15.3819 22.1823 15.4578C22.2022 15.5336 22.2022 15.6023 22.1805 15.6619C22.1589 15.7215 22.1119 15.7883 22.0397 15.8569L21.5086 16.3681L20.2551 15.0676L21.039 14.3126C21.104 14.2512 21.1636 14.2006 21.2178 14.1663C21.272 14.1302 21.3298 14.1085 21.3876 14.1013C21.4454 14.0941 21.5086 14.0959 21.5754 14.1103C21.6441 14.1248 21.7199 14.15 21.8048 14.1844C21.8897 14.2205 21.9855 14.2675 22.0866 14.3234L22.3305 14.0886L21.608 13.3391L19.2888 15.5752L19.4062 15.6962C19.5055 15.6492 19.5796 15.6167 19.6265 15.6041Z"
                fill="#040000"
              />
              <path
                d="M22.9934 12.548C23.0422 12.5426 23.0909 12.548 23.1343 12.566C23.1794 12.5841 23.2264 12.6184 23.2788 12.6708C23.3293 12.7232 23.4016 12.8153 23.4919 12.9435L25.2096 15.3802C25.3072 15.5192 25.374 15.6258 25.4101 15.7035C25.4462 15.7793 25.4571 15.8498 25.4426 15.9148C25.4282 15.9798 25.374 16.0683 25.2801 16.1803L25.3776 16.3176L26.6131 15.4452L26.5155 15.3079C26.409 15.3531 26.3259 15.3784 26.2681 15.3874C26.2103 15.3964 26.1543 15.391 26.1019 15.3693C26.0495 15.3495 25.9935 15.3097 25.9357 15.2519C25.8779 15.1941 25.8093 15.111 25.7316 15.0008L25.0724 14.0652C25.1916 13.9912 25.3559 13.881 25.5655 13.7347C25.7515 13.6028 25.9141 13.4565 26.0513 13.294C26.1904 13.1314 26.2861 12.958 26.3403 12.7701C26.3945 12.5841 26.3999 12.389 26.3566 12.1849C26.315 11.9808 26.2247 11.7821 26.0875 11.5871C25.8454 11.2439 25.5582 11.0633 25.2241 11.047C24.8899 11.0307 24.5052 11.177 24.0645 11.4859L22.6683 12.4703L22.7658 12.6076C22.8688 12.5751 22.9446 12.5534 22.9934 12.548ZM24.1169 11.8219C24.2415 11.7352 24.3643 11.6683 24.4889 11.6214C24.6136 11.5744 24.7364 11.5564 24.8592 11.569C24.982 11.5816 25.1031 11.6268 25.2223 11.7027C25.3415 11.7803 25.4589 11.8995 25.5727 12.0603C25.7226 12.2716 25.8057 12.4685 25.8238 12.6491C25.8418 12.8298 25.8003 12.9959 25.7009 13.1476C25.6016 13.3012 25.4463 13.4511 25.2349 13.601L24.908 13.8322L23.7068 12.1289C23.7935 12.0549 23.9308 11.9519 24.1169 11.8219Z"
                fill="#040000"
              />
              <path
                d="M26.7468 10.0662C26.7973 10.068 26.8425 10.0806 26.884 10.1059C26.9256 10.1312 26.9671 10.1727 27.0105 10.2324C27.0538 10.292 27.1098 10.3931 27.1802 10.534L28.5042 13.2036C28.5801 13.3553 28.6289 13.4727 28.6523 13.554C28.6758 13.6353 28.6758 13.7057 28.6523 13.7672C28.6289 13.8286 28.562 13.908 28.45 14.0038L28.5259 14.1555L31.3834 12.7376L30.9047 11.625L30.5995 11.7767C30.6284 11.9374 30.6482 12.0603 30.6609 12.1452C30.6735 12.2301 30.6789 12.3149 30.6771 12.3998C30.6753 12.4847 30.6627 12.5606 30.6392 12.6256C30.6139 12.6906 30.576 12.7466 30.5218 12.7954C30.4676 12.8442 30.3899 12.8929 30.2888 12.9435L29.3297 13.4204L28.4464 11.6394L29.1075 11.3107C29.205 11.2637 29.2827 11.2402 29.3459 11.242C29.4073 11.2457 29.4706 11.2691 29.5374 11.3143C29.6042 11.3594 29.6819 11.4371 29.7722 11.5455L30.063 11.401L29.4742 10.2161L29.1834 10.3606C29.2177 10.5087 29.2339 10.6207 29.2303 10.6984C29.2267 10.7778 29.2068 10.8429 29.1671 10.8934C29.1274 10.944 29.0642 10.9928 28.9738 11.0379L28.3128 11.3649L27.5108 9.74828L28.4862 9.26421C28.5674 9.22447 28.6379 9.19557 28.7011 9.17932C28.7643 9.16126 28.8239 9.15764 28.8817 9.16848C28.9395 9.17932 28.9991 9.20099 29.0587 9.23531C29.1183 9.26963 29.1852 9.31659 29.2556 9.3762C29.3261 9.4358 29.4019 9.50805 29.4832 9.59475L29.7848 9.44484L29.3224 8.51282L26.4361 9.94516L26.5119 10.0969C26.6185 10.0734 26.698 10.0644 26.7468 10.0662Z"
                fill="#040000"
              />
              <path
                d="M32.272 11.8363C32.6766 12.1217 33.157 12.1759 33.7134 11.9971C33.9717 11.914 34.2047 11.8255 34.4106 11.7297C34.6165 11.634 34.8152 11.5256 35.003 11.4046L34.7032 10.4654L34.3781 10.5683C34.3781 10.8067 34.3564 10.9946 34.313 11.1319C34.2715 11.2673 34.201 11.3811 34.1035 11.4678C34.006 11.5545 33.8687 11.6286 33.6881 11.6846C33.4515 11.7604 33.2275 11.746 33.0162 11.6448C32.8048 11.5419 32.6098 11.3522 32.4291 11.0759C32.2485 10.7995 32.0914 10.4473 31.9541 10.0174C31.8186 9.59115 31.7518 9.21184 31.7572 8.87769C31.7626 8.54534 31.8277 8.2744 31.9559 8.06849C32.0841 7.86258 32.2612 7.7235 32.4869 7.65125C32.6387 7.60248 32.7741 7.58623 32.8969 7.59887C33.0198 7.61332 33.139 7.66389 33.2564 7.75059C33.3738 7.83729 33.4894 7.96734 33.6014 8.14074L33.9265 8.03598L33.6357 7.12744C33.4009 7.14009 33.1968 7.16176 33.0216 7.19608C32.8464 7.2304 32.6585 7.27736 32.4598 7.34058C32.0625 7.46882 31.75 7.67293 31.5242 7.95831C31.2984 8.2437 31.1684 8.58508 31.1341 8.98425C31.0979 9.38343 31.1557 9.81693 31.3057 10.2866C31.5459 11.0361 31.8674 11.5509 32.272 11.8363Z"
                fill="#040000"
              />
              <path
                d="M36.8924 8.10279C36.9863 8.24187 37.1164 8.3665 37.2862 8.47668C37.4559 8.58686 37.6817 8.69162 37.9635 8.79458C38.2543 8.90115 38.4747 8.99688 38.621 9.08538C38.7673 9.17389 38.8756 9.27143 38.9479 9.38161C39.0201 9.49179 39.0653 9.63087 39.0852 9.80246C39.1159 10.0698 39.0671 10.2811 38.9389 10.4364C38.8124 10.5918 38.6155 10.6839 38.3482 10.7146C38.155 10.7363 37.9924 10.7254 37.8623 10.6839C37.7323 10.6424 37.6221 10.5665 37.5318 10.4599C37.4415 10.3516 37.362 10.1998 37.2934 10.0048L36.9502 10.0427L37.055 10.9801C37.5372 11.0488 37.9563 11.0632 38.3139 11.0235C38.5361 10.9982 38.7366 10.953 38.9172 10.8844C39.0978 10.8176 39.2495 10.7236 39.3706 10.6044C39.4916 10.4852 39.5819 10.3389 39.6379 10.1655C39.6939 9.99212 39.7101 9.7844 39.683 9.54597C39.6596 9.33103 39.5927 9.1486 39.4843 8.99869C39.376 8.84696 39.2351 8.71872 39.0599 8.61034C38.8847 8.50378 38.6426 8.39179 38.3338 8.2798C38.0791 8.18769 37.884 8.10099 37.7504 8.01971C37.6167 7.93842 37.5137 7.8445 37.4433 7.73793C37.3729 7.63136 37.3277 7.49951 37.3096 7.33695C37.2934 7.18342 37.3114 7.04795 37.3674 6.93054C37.4234 6.81314 37.5065 6.71921 37.6185 6.65058C37.7305 6.58194 37.8605 6.5404 38.0086 6.52414C38.1802 6.50427 38.3211 6.5115 38.4331 6.54401C38.5451 6.57652 38.6481 6.64516 38.7402 6.74631C38.8323 6.84926 38.9154 6.99737 38.9912 7.19245L39.3308 7.15452L39.2279 6.22972C38.9714 6.1936 38.76 6.17554 38.5921 6.17554C38.4241 6.17554 38.2543 6.18637 38.0809 6.20444C37.7811 6.23695 37.5228 6.31823 37.3024 6.44828C37.082 6.57652 36.9231 6.7427 36.8238 6.94319C36.7244 7.14549 36.6901 7.37307 36.719 7.62956C36.7425 7.80476 36.7985 7.96191 36.8924 8.10279Z"
                fill="#040000"
              />
              <path
                d="M40.6674 9.76452C40.6674 10.1384 40.7397 10.4148 40.8842 10.59C41.0287 10.7652 41.249 10.8537 41.5453 10.8537C41.7006 10.8537 41.8523 10.8176 41.9986 10.7471C42.1449 10.6767 42.2985 10.5611 42.4628 10.4021L42.3075 10.2161C42.2298 10.2865 42.1504 10.3425 42.0691 10.3805C41.9878 10.4184 41.9029 10.4364 41.8108 10.4364C41.7096 10.4364 41.6265 10.4202 41.5633 10.3877C41.4983 10.3552 41.4423 10.3028 41.3917 10.2269C41.3412 10.1511 41.3068 10.0481 41.2888 9.91625C41.2707 9.78439 41.2617 9.60738 41.2617 9.38341V7.84991H42.3743V7.50131H41.2617V6.65057H40.7722C40.7469 6.8601 40.7234 7.01905 40.6999 7.12742C40.6765 7.23579 40.6458 7.32791 40.6042 7.40016C40.5645 7.47241 40.5085 7.53202 40.438 7.57717C40.3676 7.62233 40.2737 7.65484 40.1599 7.6729V7.84811H40.6692L40.6674 9.76452Z"
                fill="#040000"
              />
              <path
                d="M42.9739 10.7923C43.0986 10.8736 43.2485 10.926 43.4219 10.944C43.6188 10.9657 43.8084 10.944 43.9927 10.879C44.1769 10.814 44.3792 10.6912 44.6014 10.5105L44.6519 10.5304L44.5797 11.0181L45.5171 11.1229L45.5352 10.9549C45.4376 10.9169 45.369 10.8826 45.3257 10.8519C45.2841 10.8212 45.2534 10.7869 45.2353 10.749C45.2173 10.711 45.2046 10.6623 45.1992 10.6008C45.1938 10.5394 45.1938 10.4744 45.1992 10.4058C45.2046 10.3353 45.2173 10.2161 45.2353 10.0481L45.369 8.85602C45.4033 8.55619 45.3925 8.33041 45.3419 8.17326C45.2895 8.01793 45.1992 7.8951 45.071 7.8084C44.9427 7.72171 44.7639 7.66571 44.5381 7.64042C44.3882 7.62417 44.2365 7.62236 44.0884 7.63681C43.9385 7.65126 43.7886 7.67655 43.6368 7.71448C43.4851 7.75241 43.2918 7.81563 43.0606 7.90414L43.0101 8.34847L43.458 8.39904C43.5339 8.21842 43.6314 8.08657 43.7506 8.00528C43.8698 7.924 44.0179 7.8933 44.1968 7.91317C44.3611 7.93123 44.4894 7.97819 44.5797 8.05225C44.67 8.12811 44.7314 8.23648 44.7621 8.37737C44.7928 8.52006 44.7946 8.70972 44.7675 8.94633L44.7422 9.1685C44.0794 9.12335 43.5736 9.17392 43.2232 9.31842C42.8728 9.46292 42.6795 9.70134 42.6416 10.0355C42.6235 10.1944 42.6434 10.3407 42.7012 10.4708C42.7572 10.6045 42.8493 10.711 42.9739 10.7923ZM43.2431 10.0192C43.2702 9.77901 43.4056 9.61284 43.6495 9.52072C43.8933 9.4286 44.2473 9.40512 44.7115 9.45208L44.6574 9.93435C44.6447 10.0481 44.5959 10.1601 44.5129 10.2685C44.4298 10.3769 44.3196 10.4618 44.1841 10.5232C44.0487 10.5846 43.9042 10.6063 43.7488 10.5882C43.6386 10.5756 43.5465 10.5503 43.4689 10.5141C43.393 10.4762 43.3316 10.4166 43.2882 10.3353C43.2431 10.2559 43.2286 10.1493 43.2431 10.0192Z"
                fill="#040000"
              />
              <path
                d="M47.2132 11.3521C47.1067 11.2943 47.0344 11.2384 46.9947 11.1878C46.955 11.1354 46.9351 11.0704 46.9369 10.9909C46.9387 10.9114 46.964 10.776 47.0128 10.5845L47.3325 9.34C47.3595 9.23343 47.4047 9.14493 47.4679 9.07268C47.5311 9.00043 47.6197 8.93541 47.7353 8.87399C47.8509 8.81258 47.952 8.77646 48.0387 8.76201C48.1254 8.74756 48.2121 8.75117 48.2988 8.77284C48.3855 8.79452 48.4541 8.82342 48.5011 8.85593C48.5499 8.88844 48.5896 8.92637 48.6239 8.96972C48.6582 9.01307 48.6817 9.06003 48.6998 9.11422C48.7178 9.16841 48.7269 9.23705 48.7269 9.32375C48.7269 9.41044 48.716 9.51882 48.6926 9.64706C48.6691 9.7753 48.6366 9.918 48.5968 10.0751L48.3729 10.9494C48.3349 11.1011 48.297 11.2113 48.2645 11.2817C48.2302 11.3521 48.1958 11.4027 48.1615 11.4316C48.1272 11.4605 48.0875 11.4804 48.0441 11.4912C48.0008 11.5021 47.9321 11.5093 47.84 11.5129L47.7985 11.6755L49.1134 12.0132L49.155 11.8489C49.0574 11.7929 48.9906 11.7459 48.9563 11.7098C48.9202 11.6737 48.8967 11.6339 48.884 11.5906C48.8714 11.5472 48.8696 11.4894 48.8786 11.419C48.8876 11.3467 48.9111 11.2347 48.9509 11.0812L49.2742 9.82227C49.3211 9.63803 49.35 9.48269 49.3573 9.35626C49.3645 9.22982 49.3555 9.11783 49.332 9.0203C49.3085 8.92276 49.2669 8.83606 49.2091 8.75839C49.1514 8.68253 49.0791 8.61751 48.9924 8.56513C48.9057 8.51275 48.8009 8.4712 48.6817 8.4405C48.5661 8.4116 48.4523 8.40257 48.3385 8.41521C48.2247 8.42785 48.1091 8.45675 47.9899 8.50191C47.8707 8.54706 47.7064 8.63196 47.4986 8.75659L47.4553 8.7313L47.6323 8.19665L47.4282 8.14427L46.6389 7.97449L46.5937 8.1515C46.6894 8.19485 46.7617 8.23639 46.8086 8.27613C46.8556 8.31587 46.8863 8.36463 46.9008 8.42424C46.9134 8.48385 46.9116 8.5561 46.8935 8.6446C46.8755 8.73311 46.8484 8.8469 46.8123 8.98959L46.4384 10.4436C46.3986 10.5989 46.3625 10.7127 46.3282 10.7814C46.2957 10.8518 46.2614 10.9006 46.2252 10.9295C46.1909 10.9584 46.153 10.9783 46.1096 10.9891C46.0681 10.9999 45.9994 11.0072 45.9073 11.0126L45.8658 11.1751L47.1735 11.5111L47.2132 11.3521Z"
                fill="#040000"
              />
              <path
                d="M50.5819 12.6708C50.7083 12.725 50.8365 12.7539 50.9648 12.7575C51.093 12.7629 51.2231 12.7502 51.3513 12.7195C51.4796 12.6906 51.6403 12.6328 51.8336 12.5479L51.8751 12.5805L51.6168 13.0844L51.8065 13.1639L52.5687 13.4493L52.6392 13.2831C52.5344 13.2108 52.4658 13.153 52.4314 13.1079C52.3971 13.0627 52.3791 13.014 52.3755 12.9634C52.3718 12.9128 52.3827 12.8496 52.4062 12.7755C52.4296 12.7015 52.4766 12.5823 52.547 12.4179L54.0986 8.7422L53.9108 8.66273L53.1287 8.37012L53.0582 8.53448C53.1576 8.59951 53.2244 8.65008 53.2587 8.68621C53.2912 8.72233 53.3147 8.76207 53.3255 8.80361C53.3364 8.84516 53.3364 8.89754 53.3273 8.95895C53.3183 9.02036 53.2966 9.09261 53.2659 9.17389C53.2352 9.25517 53.1774 9.39787 53.0907 9.60197L52.8776 10.1059C52.7782 10.0048 52.6771 9.91806 52.5723 9.84762C52.4676 9.77718 52.3447 9.71215 52.2057 9.65255C51.9456 9.54237 51.6855 9.50263 51.4272 9.53333C51.1689 9.56404 50.9268 9.67422 50.7011 9.86388C50.4753 10.0535 50.291 10.3227 50.1429 10.6695C49.9334 11.1662 49.8666 11.587 49.9442 11.9302C50.0219 12.2734 50.2351 12.5245 50.5819 12.6708ZM50.7805 10.8392C50.9521 10.4328 51.1544 10.1511 51.3874 9.99393C51.6204 9.83678 51.8733 9.81511 52.1443 9.93071C52.2436 9.97225 52.3249 10.0192 52.3863 10.0698C52.4477 10.1204 52.4983 10.1818 52.538 10.254C52.5777 10.3263 52.6012 10.4021 52.6067 10.4852C52.6139 10.5683 52.603 10.6622 52.5759 10.767C52.5488 10.8718 52.5001 11.0072 52.4314 11.1734L52.1316 11.8851C52.0883 11.988 52.0449 12.0711 52.0016 12.1289C51.9582 12.1885 51.9131 12.2373 51.8625 12.2752C51.8119 12.3131 51.7433 12.3511 51.6566 12.3872C51.5699 12.4233 51.4886 12.445 51.4145 12.4558C51.3405 12.4667 51.27 12.4649 51.2014 12.4558C51.1328 12.445 51.0533 12.4215 50.9594 12.3818C50.7227 12.2824 50.5909 12.1018 50.5638 11.8399C50.5367 11.578 50.6089 11.2456 50.7805 10.8392Z"
                fill="#040000"
              />
              <path
                d="M55.1065 11.5797C55.2492 11.5545 55.3955 11.587 55.5508 11.6791C55.6935 11.764 55.7892 11.8597 55.8416 11.9645C55.894 12.071 55.903 12.1939 55.8723 12.3366C55.8416 12.4793 55.7639 12.6527 55.6411 12.8568L55.5273 13.05C54.9421 12.7357 54.4598 12.5714 54.0805 12.5587C53.7012 12.5461 53.4267 12.6834 53.2551 12.9705C53.172 13.1078 53.1305 13.2487 53.1286 13.3914C53.1268 13.5341 53.1666 13.6678 53.246 13.7942C53.3255 13.9206 53.4411 14.029 53.591 14.1175C53.7608 14.2187 53.9433 14.2783 54.1365 14.2945C54.3316 14.3108 54.5664 14.2837 54.8428 14.2096L54.8807 14.2476L54.6134 14.6612L55.4244 15.1453L55.5111 15.0008C55.4388 14.9249 55.3901 14.8653 55.363 14.8201C55.3377 14.775 55.3232 14.7316 55.3232 14.6901C55.3214 14.6485 55.3305 14.598 55.3521 14.5402C55.372 14.4824 55.4009 14.4246 55.4334 14.3632C55.4677 14.3017 55.5273 14.1988 55.614 14.0525L56.2281 13.0229C56.3817 12.7646 56.4684 12.5533 56.4846 12.3907C56.5027 12.2282 56.4702 12.0783 56.3889 11.9464C56.3076 11.8146 56.1704 11.6899 55.9735 11.5725C55.8434 11.4949 55.7061 11.4316 55.5653 11.3829C55.4226 11.3341 55.2745 11.2962 55.1209 11.2655C54.9674 11.2366 54.7651 11.2149 54.5176 11.2004L54.2882 11.5852L54.6766 11.8164C54.8211 11.6845 54.9638 11.605 55.1065 11.5797ZM55.1336 13.7093C55.074 13.8086 54.9855 13.8899 54.8626 13.9531C54.7398 14.0164 54.6061 14.0489 54.458 14.0489C54.3099 14.0489 54.169 14.0091 54.0336 13.9279C53.9396 13.8719 53.8638 13.8104 53.8096 13.7454C53.7554 13.6786 53.7247 13.6009 53.7175 13.5088C53.7103 13.4167 53.741 13.3137 53.8078 13.2017C53.9306 12.994 54.1239 12.9001 54.384 12.9164C54.6441 12.9326 54.9764 13.0591 55.3792 13.2921L55.1336 13.7093Z"
                fill="#040000"
              />
              <path
                d="M56.3076 15.2049C56.2498 15.2573 56.1992 15.288 56.1559 15.3007C56.1107 15.3133 56.0673 15.3151 56.0258 15.3079C55.9825 15.3007 55.9192 15.2826 55.8325 15.2501L55.7296 15.3837L56.8278 16.2327L56.9307 16.099C56.8513 16.0105 56.7989 15.9346 56.7754 15.8696C56.7519 15.8046 56.7537 15.7323 56.7826 15.6547C56.8115 15.577 56.8892 15.4542 57.0174 15.2898L57.7544 14.3361C57.8212 14.2494 57.8916 14.1826 57.9639 14.1356C58.0361 14.0905 58.1301 14.0525 58.2457 14.0273C58.3613 14.0002 58.466 13.9929 58.5618 14.0056C58.6557 14.0164 58.7352 14.0489 58.802 14.0995C58.8869 14.1663 58.9375 14.2404 58.9519 14.3217C58.9664 14.4048 58.9573 14.5113 58.9266 14.6432L59.2355 14.8816L59.7196 14.2548C59.6419 14.179 59.5516 14.0995 59.445 14.0182C59.3204 13.9207 59.1921 13.8539 59.0639 13.8159C58.9356 13.778 58.802 13.7599 58.6611 13.7635C58.5202 13.7672 58.354 13.7924 58.1608 13.8358L58.1283 13.7979L58.5274 13.3445L58.3613 13.2163L57.702 12.7502L57.5918 12.8929C57.6623 12.9706 57.711 13.0374 57.7399 13.0916C57.7688 13.1458 57.7779 13.2036 57.7652 13.2632C57.7544 13.3228 57.7237 13.3897 57.6713 13.4637C57.6207 13.5378 57.5503 13.6317 57.46 13.7491L56.5424 14.9376C56.443 15.064 56.3654 15.1525 56.3076 15.2049Z"
                fill="#040000"
              />
              <path
                d="M58.336 16.975C58.28 17.3218 58.3848 17.6288 58.6521 17.8943C58.7497 17.9919 58.858 18.0659 58.9754 18.1183C59.0928 18.1707 59.2175 18.2068 59.3475 18.2285C59.4776 18.2502 59.6474 18.2556 59.8587 18.2484L59.8858 18.2953L59.4577 18.6674L59.604 18.8137L60.2055 19.3628L60.3319 19.2364C60.2615 19.1316 60.2199 19.0503 60.2037 18.9961C60.1874 18.9419 60.1892 18.8896 60.2055 18.8408C60.2217 18.792 60.2542 18.7378 60.303 18.6782C60.3518 18.6186 60.4403 18.5247 60.5667 18.3983L63.3808 15.5697L63.2363 15.427L62.6204 14.8635L62.494 14.9899C62.5626 15.0874 62.606 15.1597 62.6222 15.2048C62.6385 15.25 62.6457 15.2952 62.6403 15.3385C62.6349 15.3819 62.615 15.4306 62.5825 15.483C62.55 15.5354 62.5048 15.595 62.4452 15.66C62.3856 15.725 62.279 15.8352 62.1237 15.9906L61.7372 16.3789C61.683 16.247 61.6216 16.1296 61.5493 16.0249C61.4789 15.9201 61.3886 15.8154 61.282 15.707C61.0815 15.5083 60.8557 15.3746 60.6047 15.306C60.3536 15.2374 60.0881 15.25 59.8081 15.3421C59.5281 15.4342 59.2554 15.6149 58.9899 15.8822C58.6106 16.2633 58.392 16.6282 58.336 16.975ZM60.3988 15.7124C60.6733 15.6546 60.9153 15.7287 61.1249 15.9364C61.2007 16.0122 61.2585 16.0863 61.2964 16.1567C61.3344 16.2272 61.3597 16.303 61.3687 16.3843C61.3777 16.4656 61.3705 16.5451 61.347 16.6245C61.3217 16.704 61.2766 16.7871 61.2116 16.8756C61.1465 16.9641 61.0508 17.0689 60.9244 17.1953L60.3807 17.7426C60.3012 17.8221 60.2308 17.8817 60.1694 17.9214C60.1079 17.9612 60.0465 17.9883 59.9851 18.0063C59.9237 18.0244 59.846 18.0316 59.7521 18.0334C59.6582 18.0334 59.5751 18.0244 59.5029 18.0063C59.4306 17.9883 59.3656 17.9612 59.306 17.9268C59.2464 17.8925 59.1813 17.8383 59.1091 17.7679C58.9267 17.5873 58.8707 17.3687 58.9447 17.1176C59.017 16.8648 59.2084 16.583 59.5191 16.2705C59.8298 15.9562 60.1224 15.7702 60.3988 15.7124Z"
                fill="#040000"
              />
              <path
                d="M65.6458 40.0641C65.6458 26.3078 54.4941 15.1561 40.7378 15.1561C26.9815 15.1561 15.8298 26.3078 15.8298 40.0641C15.8298 53.8204 26.9815 64.9721 40.7378 64.9721C54.4941 64.9721 65.6458 53.8204 65.6458 40.0641ZM50.1321 28.9034L52.3465 27.7853C53.1575 27.4223 53.5711 28.3868 53.5711 28.3868L58.7388 39.2549C59.2174 40.2917 58.2258 40.709 58.2258 40.709L56.1541 41.7024C55.4713 42.0311 55.0053 41.2165 55.0053 41.2165C55.0053 41.2165 50.011 30.3267 49.7618 30.1045C49.406 29.2195 50.1321 28.9034 50.1321 28.9034ZM33.7748 46.1385C33.7748 46.1385 34.8477 45.8676 35.4961 46.6623C35.4961 46.6623 36.0904 47.1554 36.0217 48.1163C36.0217 48.1163 36.1933 48.3168 36.5365 48.5697C36.5365 48.5697 37.5914 48.297 38.1043 48.94C38.1043 48.94 38.7311 49.5487 38.6841 50.2621L39.6649 51.0081C39.6649 51.0081 40.046 51.3242 40.7252 51.8318L41.6048 52.5091C41.6048 52.5091 43.0101 53.0889 43.0895 51.624L39.7896 49.005C39.7896 49.005 39.403 47.9502 40.6132 48.1145L45.5316 51.7234C45.5316 51.7234 46.3354 52.081 46.823 51.2863C46.823 51.2863 47.2963 50.5999 46.6244 49.8557L41.3917 45.9181C41.3917 45.9181 40.9293 44.8163 42.1178 44.9012L48.3258 49.4764C48.3258 49.4764 49.2073 49.8413 49.5794 49.1585C49.5794 49.1585 50.0833 48.4758 49.5794 47.7695L42.7265 42.5621C42.7265 42.5621 42.3147 41.3122 43.5953 41.6374L50.6613 46.8791C50.6613 46.8791 51.7306 47.2295 52.2056 46.3209C52.2056 46.3209 52.8107 45.3456 51.9997 44.54L42.004 35.4564C42.004 35.4564 40.1472 34.5316 39.0382 36.4661C39.0382 36.4661 38.8431 39.618 35.4799 40.1942C35.4799 40.1942 33.186 40.0099 33.7188 38.4421C33.7188 38.4421 34.3907 37.5137 34.3329 35.5612C34.3329 35.5612 34.4088 34.1595 35.3426 32.9638H31.7428L32.5339 31.2569H37.9707C37.9707 31.2569 40.2032 29.9384 41.8884 30.0612C41.8884 30.0612 44.0848 30.184 44.6736 30.5344C44.6736 30.5344 47.5817 31.5026 48.8858 31.2768L53.7518 41.78L52.9787 43.6152C52.9787 43.6152 54.402 45.1397 53.3526 46.9874C53.06 47.6088 52.3086 48.2066 51.0821 48.2644C51.0821 48.2644 51.27 49.5107 50.4102 50.2134C50.4102 50.2134 49.7762 51.1165 48.2445 50.8672C48.2445 50.8672 48.333 51.969 47.3161 52.7006C47.3161 52.7006 46.1078 53.7825 44.2401 52.4639C44.2401 52.4639 43.9439 53.703 42.4519 53.9559C42.4519 53.9559 41.3646 54.1329 40.7306 53.4953C40.7306 53.4953 39.5927 55.7296 37.9707 54.4707C37.9707 54.4707 36.9429 53.5838 37.6636 52.3303C37.6636 52.3303 36.2818 54.6061 34.64 52.8956C34.64 52.8956 33.7278 52.184 34.5713 50.6902C34.5713 50.6902 33.2672 52.2364 31.8331 50.8347C31.8331 50.8347 30.8541 50.002 31.6362 48.4505C31.6362 48.4505 30.4947 49.9569 28.748 48.5281C28.748 48.5281 27.7636 47.6539 28.609 46.3173L29.9745 44.372L27.9443 41.6644L28.6288 40.1544L31.0293 43.3117C31.0293 43.3117 32.5899 42.9397 33.1372 43.9566C33.1372 43.9566 33.652 44.5743 33.428 45.7411C33.428 45.7429 33.6556 45.9994 33.7748 46.1385ZM25.0597 41.6771L23.0295 40.5897C22.3594 40.2339 22.6863 39.3489 22.6863 39.3489C22.6863 39.3489 27.8287 28.5367 27.8413 28.199C28.2893 27.3591 28.9756 27.7564 28.9756 27.7564L31.1901 28.8817C31.9667 29.3206 31.4917 30.2563 31.4917 30.2563L26.4686 41.1984C25.9827 42.228 25.0597 41.6771 25.0597 41.6771Z"
                fill="#51ACE0"
              />
            </svg>
          </div>
          <div>
            <div>履约动态考评</div>
            <div v-if="!info.gradeId">暂不支持申请</div>
            <el-rate
              v-else
              :value="turnNumber(info.gradeId)"
              disabled
              :colors="['#71B1CC', '#71B1CC', '#71B1CC']"
              disabled-void-color="#D9D9D9"
            />
          </div>
        </div>
        <div :class="{ 'not-support': !info.innovationEvaluateStringStutes }">
          <div>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.4148 66.7061C32.5322 66.7729 32.6135 66.8271 32.6586 66.8686C32.7038 66.9102 32.7363 66.9589 32.7561 67.0149C32.776 67.0709 32.7814 67.1432 32.7742 67.2335C32.767 67.3238 32.7399 67.4629 32.6929 67.6525L31.8241 71.209C31.7754 71.4113 31.7284 71.5594 31.6869 71.6551C31.6453 71.7491 31.5893 71.8159 31.5171 71.8556C31.4466 71.8954 31.3202 71.9152 31.1396 71.9189L31.0908 72.1212L34.8983 73.0514L35.33 71.628L34.9236 71.5287C34.8225 71.7021 34.7448 71.834 34.6906 71.9225C34.6346 72.0128 34.5732 72.0959 34.5046 72.1753C34.4359 72.2548 34.3637 72.3144 34.2896 72.356C34.2156 72.3975 34.1343 72.4192 34.044 72.4228C33.9537 72.4246 33.8435 72.4101 33.708 72.3776L32.4292 72.0652L33.009 69.6918L33.8887 69.9067C34.0169 69.9374 34.109 69.979 34.165 70.0313C34.221 70.0837 34.2607 70.156 34.2878 70.2517C34.3131 70.3474 34.3258 70.4811 34.324 70.6545L34.7105 70.7484L35.097 69.1698L34.7105 69.0758C34.6256 69.2402 34.5515 69.3594 34.4865 69.4299C34.4215 69.5003 34.3492 69.5455 34.2734 69.5635C34.1957 69.5816 34.0982 69.5744 33.9772 69.5455L33.0975 69.3305L33.6249 67.1757L34.9236 67.4936C35.0302 67.5189 35.1205 67.5496 35.1928 67.5839C35.265 67.6182 35.3246 67.6616 35.3716 67.7175C35.4185 67.7717 35.4565 67.8404 35.4854 67.9198C35.5161 67.9993 35.5396 68.0951 35.5594 68.2088C35.5775 68.3208 35.5919 68.4491 35.601 68.5936L36.0038 68.6929L36.3072 67.4502L32.4617 66.511L32.4148 66.7061Z"
                fill="black"
              />
              <path
                d="M44.3864 73.1852C44.3286 73.1527 44.2835 73.1111 44.2528 73.0605C44.2221 73.01 44.2004 72.9413 44.186 72.8546C44.1715 72.7679 44.1625 72.6289 44.1589 72.441L44.0902 68.7798C44.0866 68.5847 44.092 68.4402 44.1047 68.3481C44.1191 68.2541 44.1408 68.1837 44.1733 68.1367C44.2058 68.0898 44.2474 68.05 44.3034 68.0175C44.3575 67.985 44.4461 67.9525 44.5707 67.92L44.5671 67.7123L43.1365 67.7394L41.5796 71.8883L40.0172 67.7972L38.5053 67.8261L38.509 68.0338C38.639 68.0681 38.7311 68.0988 38.7853 68.1277C38.8395 68.1566 38.8829 68.1945 38.9172 68.2433C38.9497 68.2921 38.975 68.3607 38.9912 68.4492C39.0075 68.5377 39.0165 68.6804 39.0201 68.8737L39.0888 72.5349C39.0924 72.7445 39.087 72.8998 39.0707 73.0009C39.0544 73.1039 39.0165 73.1816 38.9587 73.2376C38.9009 73.2936 38.7853 73.3459 38.6101 73.3947L38.6137 73.6024L40.1581 73.5735L40.1544 73.3658C40.0244 73.3351 39.9287 73.3026 39.8709 73.2701C39.8131 73.2376 39.7679 73.196 39.7372 73.1454C39.7065 73.0949 39.6848 73.0262 39.6704 72.9395C39.6559 72.8528 39.6469 72.7137 39.6433 72.5259L39.6144 70.9762C39.6053 70.4993 39.5909 70.0351 39.5692 69.5835C39.5475 69.132 39.5295 68.8213 39.5114 68.6497L39.5837 68.6479L41.2201 72.8817L41.706 72.8727L43.3045 68.6461L43.3768 68.6443C43.3623 68.8051 43.3533 69.1049 43.3497 69.5402C43.3443 69.9755 43.3461 70.4072 43.3551 70.8335L43.3858 72.4537C43.3894 72.683 43.3822 72.8456 43.3605 72.9449C43.3388 73.0443 43.2991 73.1202 43.2377 73.1725C43.1763 73.2249 43.0661 73.2719 42.9053 73.3134L42.9089 73.5211L44.6736 73.4886L44.67 73.2809C44.5382 73.2502 44.4442 73.2177 44.3864 73.1852Z"
                fill="black"
              />
              <path
                d="M50.3037 66.6357C49.9244 66.4804 49.4169 66.493 48.7811 66.6736L46.7617 67.2462L46.8177 67.4467C46.9532 67.4467 47.0507 67.4539 47.1103 67.4666C47.1699 67.481 47.2223 67.5063 47.2674 67.546C47.3126 67.584 47.3541 67.6454 47.3921 67.7266C47.43 67.8079 47.4752 67.9434 47.5293 68.1312L48.5282 71.6534C48.5842 71.8539 48.6185 72.0056 48.6293 72.1086C48.6402 72.2115 48.6239 72.2964 48.5824 72.3669C48.5408 72.4355 48.4415 72.5168 48.2862 72.6071L48.3422 72.8076L50.1303 72.3L50.0743 72.1013C49.9334 72.1086 49.8269 72.1068 49.7546 72.0923C49.6842 72.0797 49.621 72.049 49.5686 72.0038C49.5162 71.9587 49.4674 71.8918 49.4223 71.8015C49.3771 71.7112 49.332 71.5866 49.2868 71.4258L48.9039 70.073C49.0719 70.0368 49.3085 69.9754 49.6083 69.8905C49.8774 69.8147 50.1249 69.7099 50.3525 69.578C50.5783 69.4462 50.7607 69.2836 50.8998 69.0886C51.0389 68.8935 51.1238 68.6695 51.1581 68.4166C51.1924 68.1638 51.1689 67.8964 51.0894 67.6129C50.9431 67.1161 50.683 66.791 50.3037 66.6357ZM50.3471 68.7363C50.2947 68.9531 50.1791 69.1283 50.0021 69.2656C49.8251 69.4028 49.583 69.5148 49.2778 69.6015L48.8045 69.7352L48.1055 67.2715C48.2392 67.2227 48.4397 67.1595 48.707 67.0836C48.8858 67.0331 49.0574 67.006 49.22 67.0024C49.3825 66.9987 49.5325 67.0294 49.6697 67.0927C49.807 67.1559 49.928 67.257 50.0346 67.3961C50.1412 67.5352 50.2279 67.7212 50.2947 67.9542C50.3832 68.2577 50.3994 68.5196 50.3471 68.7363Z"
                fill="black"
              />
              <path
                d="M19.6266 15.6041C19.6754 15.5915 19.7223 15.5896 19.7693 15.6005C19.8162 15.6113 19.8686 15.6384 19.9282 15.6818C19.986 15.7251 20.0709 15.8046 20.1811 15.9184L22.2492 18.0642C22.3666 18.187 22.4497 18.2827 22.4967 18.3532C22.5437 18.4236 22.5653 18.4905 22.5617 18.5573C22.5581 18.6223 22.5184 18.718 22.4407 18.8445L22.5581 18.9655L24.8538 16.7511L24.0609 15.8353L23.8152 16.0719C23.8911 16.2164 23.9471 16.3266 23.985 16.4043C24.023 16.4819 24.0537 16.5614 24.0789 16.6427C24.1042 16.724 24.1133 16.7998 24.1097 16.8685C24.106 16.9371 24.0862 17.0039 24.0482 17.0653C24.0121 17.1286 23.9525 17.199 23.8712 17.2767L23.1 18.0208L21.72 16.5903L22.251 16.0791C22.3287 16.0051 22.3973 15.9581 22.457 15.9437C22.5166 15.9274 22.5852 15.931 22.6611 15.9545C22.7369 15.978 22.8363 16.0286 22.9537 16.1044L23.1867 15.8804L22.2691 14.9286L22.0361 15.1489C22.1138 15.279 22.1625 15.3819 22.1824 15.4578C22.2023 15.5337 22.2023 15.6023 22.1806 15.6619C22.1589 15.7215 22.112 15.7883 22.0397 15.857L21.5087 16.3681L20.2552 15.0694L21.0391 14.3144C21.1041 14.253 21.1637 14.2043 21.2179 14.1681C21.2721 14.132 21.3299 14.1103 21.3877 14.1031C21.4455 14.0959 21.5087 14.0977 21.5755 14.1121C21.6441 14.1266 21.72 14.1519 21.8049 14.1862C21.8898 14.2223 21.9855 14.2693 22.0867 14.3253L22.3305 14.0905L21.608 13.3409L19.2888 15.577L19.4062 15.698C19.5056 15.6493 19.5778 15.6167 19.6266 15.6041Z"
                fill="black"
              />
              <path
                d="M22.9934 12.548C23.0422 12.5426 23.091 12.548 23.1343 12.566C23.1795 12.5841 23.2264 12.6184 23.2788 12.6708C23.3294 12.7232 23.4016 12.8153 23.492 12.9435L25.2097 15.3802C25.3072 15.5192 25.3741 15.6258 25.4102 15.7035C25.4463 15.7793 25.4571 15.8498 25.4427 15.9148C25.4282 15.9798 25.3741 16.0683 25.2801 16.1803L25.3777 16.3176L26.6131 15.4452L26.5156 15.3079C26.409 15.3531 26.3259 15.3784 26.2681 15.3874C26.2103 15.3964 26.1544 15.391 26.102 15.3693C26.0496 15.3495 25.9936 15.3097 25.9358 15.2519C25.878 15.1941 25.8094 15.111 25.7317 15.0008L25.0724 14.0652C25.1916 13.993 25.356 13.881 25.5655 13.7347C25.7516 13.6028 25.9141 13.4565 26.0514 13.294C26.1887 13.1314 26.2862 12.958 26.3404 12.7701C26.3946 12.5841 26.4 12.389 26.3566 12.1849C26.3151 11.9808 26.2248 11.7821 26.0875 11.5871C25.8455 11.2439 25.5583 11.0633 25.2241 11.047C24.89 11.0307 24.5053 11.177 24.0645 11.4859L22.6683 12.4703L22.7659 12.6076C22.8688 12.5751 22.9447 12.5534 22.9934 12.548ZM24.1169 11.8219C24.2415 11.7352 24.3644 11.6683 24.489 11.6214C24.6136 11.5744 24.7365 11.5564 24.8593 11.569C24.9821 11.5816 25.1031 11.6268 25.2223 11.7027C25.3415 11.7803 25.459 11.8995 25.5727 12.0603C25.7227 12.2716 25.8057 12.4685 25.8238 12.6491C25.8419 12.8298 25.8003 12.9959 25.701 13.1476C25.6016 13.3012 25.4463 13.4511 25.235 13.601L24.908 13.8322L23.7069 12.1289C23.7936 12.0549 23.9309 11.9519 24.1169 11.8219Z"
                fill="black"
              />
              <path
                d="M26.7468 10.0663C26.7974 10.0681 26.8425 10.0825 26.8841 10.106C26.9256 10.1295 26.9672 10.1728 27.0105 10.2324C27.0539 10.292 27.1099 10.3932 27.1803 10.5341L28.5043 13.2037C28.5801 13.3554 28.6289 13.4728 28.6524 13.5541C28.6759 13.6354 28.6759 13.7058 28.6524 13.7672C28.6289 13.8287 28.5621 13.9081 28.4501 14.0039L28.526 14.1556L31.3834 12.7377L30.9048 11.625L30.5995 11.7768C30.6284 11.9375 30.6483 12.0603 30.6609 12.1452C30.6736 12.2301 30.679 12.315 30.6772 12.3999C30.6754 12.4848 30.6627 12.5607 30.6392 12.6257C30.614 12.6907 30.576 12.7467 30.5218 12.7955C30.4677 12.8443 30.39 12.893 30.2888 12.9436L29.3297 13.4204L28.4465 11.6395L29.1076 11.3126C29.2051 11.2638 29.2828 11.2421 29.346 11.2439C29.4074 11.2475 29.4706 11.271 29.5374 11.3162C29.6043 11.3613 29.6819 11.439 29.7723 11.5474L30.0631 11.4029L29.4742 10.218L29.1834 10.3625C29.2177 10.5088 29.234 10.6226 29.2304 10.7003C29.2268 10.7797 29.2069 10.8448 29.1672 10.8953C29.1292 10.9459 29.0642 10.9947 28.9739 11.0398L28.3128 11.3668L27.5108 9.75017L28.4862 9.2661C28.5657 9.22637 28.6379 9.19747 28.7012 9.18121C28.7644 9.16315 28.824 9.15954 28.8818 9.17037C28.9396 9.18121 28.9992 9.20289 29.0588 9.2372C29.1184 9.27152 29.1852 9.31848 29.2557 9.37809C29.3261 9.4377 29.402 9.50995 29.4833 9.59664L29.7849 9.44673L29.3225 8.51471L26.4361 9.94705L26.512 10.0988C26.6186 10.0735 26.6962 10.0645 26.7468 10.0663Z"
                fill="black"
              />
              <path
                d="M32.2721 11.8363C32.6767 12.1217 33.1571 12.1759 33.7134 11.9971C33.9717 11.914 34.2047 11.8255 34.4106 11.7297C34.6166 11.634 34.8152 11.5256 35.0031 11.4046L34.7033 10.4654L34.3781 10.5683C34.3781 10.8067 34.3565 10.9946 34.3131 11.1319C34.2716 11.2673 34.2011 11.3811 34.1036 11.4678C34.006 11.5545 33.8688 11.6286 33.6881 11.6846C33.4515 11.7604 33.2276 11.746 33.0162 11.6448C32.8049 11.5419 32.6098 11.3522 32.4292 11.0759C32.2486 10.7995 32.0914 10.4473 31.9542 10.0174C31.8169 9.59115 31.7519 9.21184 31.7555 8.87769C31.7609 8.54534 31.8259 8.2744 31.9542 8.06849C32.0824 7.86258 32.2594 7.7235 32.4852 7.65125C32.6369 7.60248 32.7724 7.58623 32.8952 7.59887C33.018 7.61332 33.1372 7.66389 33.2547 7.75059C33.3721 7.83729 33.4858 7.96734 33.5996 8.14074L33.9248 8.03598L33.634 7.12744C33.3992 7.14009 33.195 7.16176 33.0198 7.19608C32.8446 7.22859 32.6568 7.27736 32.4581 7.34058C32.0607 7.46882 31.7483 7.67293 31.5225 7.95831C31.2967 8.24189 31.1666 8.58508 31.1323 8.98425C31.0962 9.38343 31.154 9.81693 31.3039 10.2847C31.546 11.0361 31.8675 11.5509 32.2721 11.8363Z"
                fill="black"
              />
              <path
                d="M36.8924 8.10282C36.9863 8.2419 37.1163 8.36653 37.2861 8.47671C37.4559 8.58689 37.6817 8.69165 37.9634 8.7946C38.2543 8.90117 38.4746 8.9969 38.6209 9.08541C38.7672 9.17391 38.8756 9.27145 38.9478 9.38163C39.0201 9.49181 39.0653 9.63089 39.0851 9.80248C39.1158 10.0698 39.0671 10.2811 38.9388 10.4365C38.8124 10.5918 38.6155 10.6839 38.3482 10.7146C38.1549 10.7363 37.9923 10.7255 37.8623 10.6839C37.7323 10.6424 37.6221 10.5665 37.5318 10.46C37.4414 10.3516 37.362 10.1999 37.2933 10.0048L36.9502 10.0427L37.0549 10.9802C37.5372 11.0488 37.9562 11.0632 38.3139 11.0235C38.536 10.9982 38.7365 10.9531 38.9171 10.8844C39.0978 10.8176 39.2495 10.7237 39.3705 10.6045C39.4915 10.4852 39.5818 10.3389 39.6378 10.1655C39.6938 9.99214 39.7101 9.78442 39.683 9.546C39.6595 9.33106 39.5927 9.14863 39.4843 8.99871C39.3759 8.84699 39.235 8.71874 39.0598 8.61037C38.8846 8.5038 38.6426 8.39181 38.3337 8.27983C38.079 8.18771 37.884 8.10101 37.7503 8.01973C37.6167 7.93845 37.5137 7.84452 37.4433 7.73796C37.3728 7.63319 37.3277 7.49953 37.3096 7.33697C37.2915 7.18344 37.3114 7.04797 37.3674 6.93057C37.4234 6.81316 37.5065 6.71924 37.6185 6.6506C37.7304 6.58196 37.8605 6.54042 38.0086 6.52417C38.1802 6.5043 38.3211 6.51152 38.4331 6.54403C38.5451 6.57655 38.648 6.64518 38.7401 6.74814C38.8322 6.85109 38.9153 6.99921 38.9912 7.19428L39.3308 7.15635L39.2278 6.23156C38.9713 6.19543 38.76 6.17737 38.592 6.17737C38.424 6.17737 38.2543 6.18821 38.0809 6.20627C37.781 6.23878 37.5227 6.32006 37.3024 6.45011C37.082 6.57835 36.9231 6.74453 36.8237 6.94502C36.7244 7.14732 36.6901 7.3749 36.719 7.63139C36.7424 7.80479 36.7984 7.96193 36.8924 8.10282Z"
                fill="black"
              />
              <path
                d="M40.6674 9.76459C40.6674 10.1385 40.7396 10.4148 40.8841 10.59C41.0286 10.7652 41.249 10.8537 41.5452 10.8537C41.7006 10.8537 41.8523 10.8176 41.9986 10.7472C42.1449 10.6767 42.2984 10.5611 42.4628 10.4022L42.3075 10.2161C42.2298 10.2884 42.1503 10.3426 42.069 10.3805C41.9878 10.4184 41.9029 10.4365 41.8107 10.4365C41.7096 10.4365 41.6265 10.4202 41.5633 10.3877C41.4983 10.3552 41.4423 10.3028 41.3917 10.227C41.3411 10.1529 41.3068 10.0482 41.2887 9.91631C41.2707 9.78445 41.2616 9.60744 41.2616 9.38347V7.84998H42.3743V7.50137H41.2616V6.65063H40.7721C40.7469 6.86016 40.7234 7.01911 40.6999 7.12748C40.6764 7.23586 40.6457 7.32797 40.606 7.40022C40.5662 7.47247 40.5102 7.53208 40.4398 7.57723C40.3675 7.62239 40.2754 7.6549 40.1598 7.67296V7.84817H40.6692L40.6674 9.76459Z"
                fill="black"
              />
              <path
                d="M42.974 10.7923C43.0986 10.8735 43.2485 10.9259 43.4219 10.944C43.6188 10.9657 43.8085 10.944 43.9927 10.879C44.177 10.8139 44.3792 10.6911 44.6014 10.5105L44.652 10.5304L44.5797 11.018L45.5172 11.1228L45.5352 10.9548C45.4377 10.9169 45.3691 10.8826 45.3257 10.8519C45.2842 10.8212 45.2535 10.7868 45.2354 10.7507C45.2173 10.7128 45.2047 10.664 45.1993 10.6026C45.1939 10.5412 45.1939 10.4762 45.2011 10.4075C45.2065 10.3371 45.2192 10.2179 45.2372 10.0499L45.3709 8.85779C45.4052 8.55796 45.3944 8.33218 45.3438 8.17503C45.2914 8.0197 45.2011 7.89687 45.0728 7.81017C44.9446 7.72348 44.7658 7.66748 44.54 7.64219C44.3901 7.62594 44.2384 7.62413 44.0903 7.63858C43.9403 7.65303 43.7904 7.67832 43.6387 7.71625C43.487 7.75418 43.2937 7.8174 43.0625 7.9059L43.0119 8.35024L43.4599 8.40081C43.5357 8.22019 43.6333 8.08833 43.7525 8.00705C43.8717 7.92577 44.0198 7.89507 44.1986 7.91494C44.363 7.933 44.4912 7.97996 44.5815 8.05402C44.6719 8.12988 44.7333 8.23825 44.764 8.37914C44.7947 8.52183 44.7965 8.71149 44.7694 8.9481L44.7441 9.17027C44.0812 9.12511 43.5755 9.17569 43.2251 9.32019C42.8747 9.46468 42.6814 9.70311 42.6435 10.0373C42.6254 10.1962 42.6453 10.3425 42.7031 10.4726C42.7572 10.6044 42.8494 10.7092 42.974 10.7923ZM43.2431 10.0192C43.2702 9.77897 43.4057 9.6128 43.6495 9.52068C43.8934 9.42856 44.2474 9.40508 44.7116 9.45204L44.6574 9.93431C44.6448 10.0481 44.596 10.1601 44.5129 10.2685C44.4298 10.3768 44.3196 10.4617 44.1842 10.5231C44.0487 10.5845 43.9042 10.6062 43.7489 10.5882C43.6387 10.5755 43.5466 10.5502 43.4689 10.5141C43.3912 10.478 43.3316 10.4166 43.2883 10.3353C43.2431 10.2558 43.2287 10.1492 43.2431 10.0192Z"
                fill="black"
              />
              <path
                d="M47.2132 11.3523C47.1067 11.2945 47.0344 11.2385 46.9947 11.1879C46.9549 11.1355 46.9351 11.0705 46.9369 10.991C46.9387 10.9115 46.964 10.7761 47.0127 10.5846L47.3324 9.34012C47.3595 9.23356 47.4047 9.14505 47.4679 9.0728C47.5311 9.00055 47.6196 8.93553 47.7352 8.87411C47.8508 8.8127 47.952 8.77658 48.0387 8.76213C48.1254 8.74768 48.2121 8.75129 48.2988 8.77297C48.3855 8.79464 48.4541 8.82354 48.5011 8.85605C48.5498 8.88856 48.5896 8.9265 48.6239 8.96985C48.6564 9.01319 48.6817 9.06016 48.6998 9.11434C48.7178 9.16672 48.7268 9.23717 48.7268 9.32387C48.7268 9.41057 48.716 9.51894 48.6925 9.64718C48.669 9.77543 48.6365 9.91812 48.5968 10.0753L48.3728 10.9495C48.3349 11.1012 48.297 11.2114 48.2644 11.2818C48.2301 11.3523 48.1958 11.4028 48.1615 11.4317C48.1272 11.4606 48.0874 11.4805 48.0441 11.4914C48.0007 11.5022 47.9321 11.5094 47.84 11.513L47.7984 11.6756L49.1134 12.0134L49.1549 11.849C49.0574 11.793 48.9906 11.7478 48.9562 11.7099C48.9201 11.6738 48.8966 11.634 48.884 11.5907C48.8713 11.5473 48.8695 11.4895 48.8786 11.4191C48.8876 11.3469 48.9111 11.2349 48.9508 11.0813L49.2741 9.82239C49.3211 9.63815 49.35 9.48282 49.3572 9.35638C49.3645 9.22994 49.3554 9.11796 49.3319 9.02042C49.3066 8.92288 49.2669 8.83618 49.2091 8.75852C49.1513 8.68265 49.0791 8.61763 48.9924 8.56525C48.9057 8.51287 48.8009 8.47132 48.6817 8.44062C48.5661 8.41172 48.4523 8.40269 48.3385 8.41533C48.2247 8.42797 48.1091 8.45687 47.9899 8.50203C47.8707 8.54719 47.7063 8.63208 47.4986 8.75671L47.4553 8.73142L47.6323 8.19678L47.4282 8.1444L46.6388 7.97461L46.5937 8.15162C46.6894 8.19497 46.7617 8.23651 46.8086 8.27625C46.8574 8.31599 46.8863 8.36476 46.9007 8.42436C46.9134 8.48397 46.9116 8.55622 46.8935 8.64472C46.8754 8.73323 46.8484 8.84702 46.8122 8.98971L46.4383 10.4437C46.3986 10.5991 46.3625 10.7129 46.3282 10.7815C46.2956 10.8519 46.2613 10.9007 46.227 10.9296C46.1927 10.9585 46.1548 10.9784 46.1114 10.9892C46.0699 11.0001 46.0012 11.0073 45.9091 11.0127L45.8676 11.1753L47.1753 11.5112L47.2132 11.3523Z"
                fill="black"
              />
              <path
                d="M50.5819 12.6708C50.7083 12.725 50.8366 12.7539 50.9648 12.7575C51.0931 12.7629 51.2231 12.7503 51.3514 12.7196C51.4796 12.6907 51.6404 12.6329 51.8336 12.548L51.8752 12.5805L51.6169 13.0844L51.8065 13.1639L52.5688 13.4493L52.6392 13.2849C52.5345 13.2127 52.4658 13.1549 52.4315 13.1097C52.3972 13.0645 52.3791 13.0158 52.3755 12.9652C52.3719 12.9146 52.3827 12.8514 52.4062 12.7774C52.4297 12.7033 52.4767 12.5841 52.5471 12.4197L54.0987 8.74403L53.9108 8.66456L53.1287 8.37195L53.0583 8.53632C53.1576 8.60134 53.2244 8.65191 53.2588 8.68804C53.2913 8.72416 53.3148 8.7639 53.3256 8.80545C53.3364 8.84699 53.3364 8.89937 53.3274 8.96078C53.3184 9.02219 53.2967 9.09444 53.266 9.17572C53.2353 9.257 53.1775 9.3997 53.0908 9.6038L52.8776 10.1077C52.7783 10.0066 52.6771 9.91989 52.5724 9.84945C52.4676 9.77901 52.3448 9.71398 52.2057 9.65438C51.9456 9.5442 51.6855 9.50446 51.4272 9.53516C51.1689 9.56587 50.9269 9.67605 50.7011 9.86571C50.4753 10.0554 50.2911 10.3245 50.143 10.6713C49.9335 11.168 49.8666 11.5889 49.9443 11.932C50.022 12.2752 50.2351 12.5245 50.5819 12.6708ZM50.7806 10.8393C50.9522 10.4329 51.1545 10.1511 51.3875 9.99395C51.6205 9.83681 51.8734 9.81513 52.1443 9.93073C52.2436 9.97227 52.3249 10.0192 52.3863 10.0698C52.4478 10.1204 52.4983 10.1818 52.5381 10.254C52.5778 10.3263 52.6013 10.4022 52.6067 10.4852C52.6139 10.5683 52.6031 10.6623 52.576 10.767C52.5489 10.8718 52.5001 11.0072 52.4315 11.1734L52.1317 11.8851C52.0883 11.988 52.045 12.0711 52.0016 12.1289C51.9583 12.1885 51.9131 12.2373 51.8625 12.2752C51.812 12.3132 51.7433 12.3511 51.6566 12.3872C51.5699 12.4233 51.4886 12.445 51.4146 12.4558C51.3405 12.4667 51.2701 12.4649 51.2014 12.4558C51.1328 12.445 51.0533 12.4215 50.9594 12.3818C50.7228 12.2824 50.5909 12.1018 50.5638 11.8399C50.5367 11.5798 50.609 11.2457 50.7806 10.8393Z"
                fill="black"
              />
              <path
                d="M55.1065 11.5798C55.2492 11.5545 55.3955 11.5888 55.5509 11.6791C55.6936 11.764 55.7893 11.8598 55.8417 11.9645C55.8941 12.0711 55.9031 12.1939 55.8724 12.3366C55.8417 12.4793 55.764 12.6527 55.6412 12.8568L55.5274 13.0501C54.9422 12.7358 54.4599 12.5714 54.0806 12.5588C53.7013 12.5461 53.4267 12.6834 53.2551 12.9706C53.172 13.1079 53.1305 13.2487 53.1287 13.3914C53.1269 13.5341 53.1666 13.6678 53.2461 13.7942C53.3256 13.9207 53.4412 14.029 53.5911 14.1176C53.7609 14.2187 53.9433 14.2783 54.1366 14.2946C54.3317 14.3126 54.5665 14.2837 54.8428 14.2097L54.8807 14.2476L54.6134 14.6612L55.4244 15.1453L55.5111 15.0008C55.4389 14.9249 55.3901 14.8653 55.363 14.8202C55.3377 14.775 55.3233 14.7317 55.3233 14.6901C55.3215 14.6486 55.3305 14.598 55.3522 14.5402C55.372 14.4824 55.4009 14.4246 55.4335 14.3632C55.4678 14.3018 55.5274 14.1988 55.6141 14.0525L56.2282 13.023C56.3817 12.7647 56.4684 12.5533 56.4847 12.389C56.5028 12.2264 56.4702 12.0765 56.389 11.9446C56.3077 11.8128 56.1704 11.6882 55.9735 11.5708C55.8435 11.4931 55.7062 11.4299 55.5653 11.3811C55.4226 11.3323 55.2745 11.2944 55.121 11.2637C54.9675 11.2348 54.7651 11.2131 54.5177 11.1987L54.2883 11.5834L54.6766 11.8146C54.8211 11.6845 54.9638 11.6051 55.1065 11.5798ZM55.1336 13.7093C55.074 13.8087 54.9855 13.89 54.8627 13.9532C54.7399 14.0164 54.6062 14.0489 54.4581 14.0489C54.31 14.0489 54.1691 14.0092 54.0336 13.9279C53.9397 13.8719 53.8638 13.8105 53.8096 13.7455C53.7555 13.6786 53.7248 13.601 53.7175 13.5088C53.7103 13.4167 53.741 13.3138 53.8078 13.2018C53.9307 12.9941 54.1239 12.8983 54.384 12.9164C54.6441 12.9327 54.9765 13.0591 55.3793 13.2921L55.1336 13.7093Z"
                fill="black"
              />
              <path
                d="M56.3076 15.2049C56.2498 15.2573 56.1992 15.288 56.1559 15.3007C56.1107 15.3133 56.0674 15.3151 56.0258 15.3079C55.9825 15.3007 55.9193 15.2826 55.8326 15.2501L55.7296 15.3837L56.8278 16.2327L56.9308 16.099C56.8513 16.0105 56.7989 15.9346 56.7754 15.8696C56.752 15.8046 56.7538 15.7323 56.7827 15.6547C56.8116 15.577 56.8892 15.4542 57.0175 15.2898L57.7544 14.3361C57.8212 14.2494 57.8917 14.1826 57.9639 14.1356C58.0362 14.0905 58.1301 14.0525 58.2457 14.0273C58.3613 14.0002 58.4661 13.9929 58.5618 14.0056C58.6557 14.0164 58.7352 14.0489 58.802 14.0995C58.8869 14.1663 58.9375 14.2404 58.952 14.3217C58.9664 14.4048 58.9574 14.5113 58.9267 14.6432L59.2355 14.8816L59.7196 14.2548C59.6419 14.1772 59.5516 14.0995 59.445 14.0182C59.3204 13.9207 59.1922 13.8539 59.0639 13.8159C58.9357 13.778 58.802 13.7599 58.6611 13.7635C58.5221 13.7672 58.3541 13.7924 58.1608 13.8358L58.1283 13.7979L58.5275 13.3445L58.3613 13.2163L57.702 12.7502L57.5919 12.8929C57.6623 12.9706 57.7111 13.0374 57.74 13.0916C57.7689 13.1458 57.7779 13.2036 57.7653 13.2632C57.7544 13.3228 57.7237 13.3897 57.6713 13.4637C57.6208 13.5378 57.5503 13.6317 57.46 13.7491L56.5424 14.9376C56.4431 15.064 56.3654 15.1525 56.3076 15.2049Z"
                fill="black"
              />
              <path
                d="M58.336 16.9751C58.28 17.3219 58.3847 17.6289 58.6521 17.8945C58.7496 17.992 58.858 18.066 58.9754 18.1184C59.0928 18.1708 59.2174 18.2069 59.3475 18.2286C59.4775 18.2503 59.6473 18.2557 59.8586 18.2485L59.8857 18.2954L59.4577 18.6675L59.604 18.8138L60.2054 19.3629L60.3319 19.2365C60.2614 19.1317 60.2199 19.0504 60.2036 18.9963C60.1892 18.9403 60.1892 18.8897 60.2054 18.8409C60.2217 18.7921 60.2542 18.738 60.303 18.6784C60.3517 18.6188 60.4402 18.5248 60.5667 18.3984L63.3808 15.5698L63.2363 15.4271L62.6204 14.8636L62.4939 14.99C62.5626 15.0876 62.6059 15.1598 62.6222 15.205C62.6384 15.2519 62.6457 15.2953 62.6402 15.3386C62.6348 15.382 62.615 15.4307 62.5824 15.4831C62.5499 15.5373 62.5048 15.5951 62.4452 15.6601C62.3856 15.7252 62.279 15.8353 62.1237 15.9907L61.7371 16.379C61.6829 16.2472 61.6215 16.1298 61.5493 16.025C61.4788 15.9202 61.3885 15.8155 61.2819 15.7071C61.0815 15.5084 60.8557 15.3748 60.6046 15.3061C60.3535 15.2375 60.088 15.2501 59.8081 15.3422C59.5281 15.4344 59.2554 15.615 58.9898 15.8823C58.6105 16.2634 58.392 16.6283 58.336 16.9751ZM60.3987 15.7125C60.6733 15.6547 60.9153 15.7288 61.1248 15.9365C61.2007 16.0124 61.2585 16.0864 61.2964 16.1569C61.3343 16.2273 61.3596 16.3032 61.3687 16.3844C61.3777 16.4657 61.3705 16.5452 61.347 16.6247C61.3217 16.7041 61.2765 16.7872 61.2115 16.8757C61.1465 16.9642 61.0507 17.0708 60.9243 17.1972L60.3806 17.7445C60.3012 17.824 60.2307 17.8836 60.1693 17.9234C60.1079 17.9631 60.0465 17.9902 59.9851 18.0082C59.9237 18.0263 59.846 18.0335 59.7521 18.0353C59.6581 18.0353 59.5751 18.0263 59.5028 18.0082C59.4306 17.9902 59.3655 17.9631 59.3059 17.9288C59.2463 17.8945 59.1813 17.8403 59.109 17.7698C58.9266 17.5892 58.8706 17.3724 58.9447 17.1196C59.0169 16.8667 59.2084 16.5849 59.5191 16.2724C59.8297 15.9564 60.1223 15.7703 60.3987 15.7125Z"
                fill="black"
              />
              <path
                d="M39.9991 0C17.9088 0 0 17.9088 0 39.9991C0 62.0894 17.9088 79.9982 39.9991 79.9982C62.0894 79.9982 79.9982 62.0894 79.9982 39.9991C79.9982 17.9088 62.0912 0 39.9991 0ZM39.9991 77.4984C19.2888 77.4984 2.49983 60.7094 2.49983 39.9991C2.49983 19.2888 19.2888 2.49983 39.9991 2.49983C60.7094 2.49983 77.4984 19.2888 77.4984 39.9991C77.4984 60.7094 60.7094 77.4984 39.9991 77.4984Z"
                fill="#51ACE0"
              />
              <path
                d="M40.7378 15.1561C26.9815 15.1561 15.8298 26.3078 15.8298 40.0641C15.8298 53.8204 26.9815 64.9721 40.7378 64.9721C54.4941 64.9721 65.6458 53.8204 65.6458 40.0641C65.6458 26.3078 54.4941 15.1561 40.7378 15.1561ZM32.5195 54.9836H28.515V47.7099H32.5195V54.9836ZM39.152 54.9854H35.1475V44.0722H39.152V54.9854ZM46.0355 54.9854H42.0311V40.3856H46.0355V54.9854ZM52.7294 54.9854H48.725V36.7984H52.7294V54.9854ZM52.0467 32.31L50.1808 30.4441L40.4181 40.2068L37.1723 36.961L28.1538 45.9814V45.9832L26.0297 43.859L37.1723 32.7145L40.4181 35.9604L48.0585 28.32L46.0518 26.3132L53.9721 24.3986L52.0467 32.31Z"
                fill="#51ACE0"
              />
            </svg>
          </div>
          <div>
            <div>市场业绩表现</div>
            <div v-if="!info.innovationEvaluateStringStutes" class="notSupport">
              暂不支持申请
            </div>
            <el-rate
              v-else
              :value="turnNumber(info.innovationEvaluateStringStutes)"
              disabled
              :colors="['#71B1CC', '#71B1CC', '#71B1CC']"
              disabled-void-color="#D9D9D9"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="home-pending">
      <div
        v-if="[USER_TYPE.SUPPLY, USER_TYPE.ALL].includes(userType)"
        class="home-pending-sale"
      >
        <div>市场销售待办业务</div>
        <div :class="{ 'home-pending-only': USER_TYPE.SUPPLY === userType }">
          <!--                    <div>-->
          <!--                        <div>-->
          <!--                            <div>5</div>-->
          <!--                            <div>目录审核通知</div>-->
          <!--                        </div>-->
          <!--                        <div>-->
          <!--                            <div>22</div>-->
          <!--                            <div>商品上架审核</div>-->
          <!--                        </div>-->
          <!--                        <div>-->
          <!--                            <div>333</div>-->
          <!--                            <div>商城审核通知</div>-->
          <!--                        </div>-->
          <!--                        <div>-->
          <!--                            <div>0</div>-->
          <!--                            <div>商城装修审核通知</div>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <div>
            <!--                        <div>-->
            <!--                            <div>5</div>-->
            <!--                            <div>商城停用通知</div>-->
            <!--                        </div>-->
            <div>
              <div @click="jump('/orderManage', 1)">
                {{ num(outsideOrderSupply.confirmCount) }}
              </div>
              <div>待确认</div>
            </div>
            <div>
              <div @click="jump('/orderManage', 1)">
                {{ num(outsideOrderSupply.sendCount) }}
              </div>
              <div>待发货</div>
            </div>
            <!--                        <div></div>-->
            <!--                        <div>-->
            <!--                            <div>0</div>-->
            <!--                            <div>协议待维护</div>-->
            <!--                        </div>-->
          </div>
        </div>
      </div>
      <div
        v-if="[USER_TYPE.PURCHASE, USER_TYPE.ALL].includes(userType)"
        class="home-pending-purchase"
      >
        <div>采购待办业务</div>
        <div :class="{ 'home-pending-only': USER_TYPE.PURCHASE === userType }">
          <div>
            <div>
              <div @click="jump(epecMallUrl + '/user/user/userOrder?type=18')">
                {{ num(outsideOrderPurchase.confirmCount) }}
              </div>
              <div>待确认</div>
            </div>
            <div>
              <div @click="jump(epecMallUrl + '/user/user/userOrder?type=12')">
                {{ num(outsideOrderPurchase.approveCount) }}
              </div>
              <div>待审批</div>
            </div>
            <div>
              <div @click="jump(epecMallUrl + '/user/user/userOrder?type=21')">
                {{ num(outsideOrderPurchase.paymentCount) }}
              </div>
              <div>待付款</div>
            </div>
            <div>
              <div @click="jump(epecMallUrl + '/user/user/userOrder?type=4')">
                {{ num(outsideOrderPurchase.receiveCount) }}
              </div>
              <div>待收货</div>
            </div>
          </div>
          <!--                    <div>-->
          <!--                        <div>-->
          <!--                            <div>{{num(outsideOrderPurchase.receiveCount)}}</div>-->
          <!--                            <div>待收货</div>-->
          <!--                        </div>-->
          <!--                        <div>-->
          <!--                            <div>22</div>-->
          <!--                            <div>协议待确认</div>-->
          <!--                        </div>-->
          <!--                        <div v-if="USER_TYPE.ALL===userType">-->
          <!--                        </div>-->
          <!--                    </div>-->
        </div>
      </div>
    </div>
    <div
      v-if="
        [USER_TYPE.ALL, USER_TYPE.SUPPLY].includes(userType) ||
        ([USER_TYPE.PURCHASE].includes(userType) && applyStatus == 102)
      "
      class="home-business"
    >
      <div v-if="[USER_TYPE.ALL, USER_TYPE.SUPPLY].includes(userType)">
        <div>
          <img src="../../../../assets/img/home/logo.png" alt="" />
          <span>管理石化销售业务</span>
        </div>
        <div>
          <e-btn-animation
            btn-height="30"
            font-size="12"
            btn-width="80"
            title="立即进入"
            @click="jump(easySeries + '/ecmall/supplierList.do')"
          />
        </div>
      </div>
      <div
        v-if="
          [USER_TYPE.ALL, USER_TYPE.PURCHASE].includes(userType) &&
          applyStatus == 102
        "
      >
        <div>
          <span>采购专属商城</span>
        </div>
        <div>
          <e-btn-animation
            btn-height="30"
            font-size="12"
            btn-width="80"
            title="立即配置"
            @click="toPurchase"
          />
        </div>
      </div>
    </div>
    <div class="home-quick-nav">
      <div @click="quickNavHidden = !quickNavHidden">
        <span>基础功能快捷导航</span>
        <span>按顺序完成</span>
        <span>以下环节操作，即可在平台上开展相关业务</span>
        <img
          :class="{ rotate: quickNavHidden }"
          src="../../../../assets/img/home/down-arrow.png"
          alt=""
        />
      </div>
      <div :class="{ quickNavHidden: quickNavHidden }">
        <div class="tab-extra">
          <span></span>
          <span>必要设置环节</span>
          <span></span>
          <span>可选择环节</span>
        </div>
        <el-tabs v-model="quickNavActive" class="tabs-area" type="card">
          <el-tab-pane label="平台销售业务" name="0">
            <div class="steps">
              <div>
                <div>
                  <svg
                    width="7"
                    height="11"
                    viewBox="0 0 7 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.61832 10.92H1.19832L2.33232 2.856L0.92832 3.054L1.19832 1.182L6.07632 0.497999L4.61832 10.92Z"
                      fill="#F5F5F5"
                    />
                  </svg>
                </div>
              </div>
              <div>
                <div>
                  <svg
                    width="12"
                    height="11"
                    viewBox="0 0 12 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11099 2.37H4.67299L4.51099 3.738H1.09099L1.52299 0.659999H11.765L10.901 6.816H3.71899L3.39499 9.21H9.89299L10.667 8.526L10.325 10.92H1.30699C0.958992 10.92 0.682992 10.806 0.478992 10.578C0.274992 10.338 0.196992 10.044 0.244992 9.696L0.892992 5.106H7.71499L8.11099 2.37Z"
                      fill="#F5F5F5"
                    />
                  </svg>
                </div>
              </div>
              <div>
                <div>
                  <svg
                    width="13"
                    height="11"
                    viewBox="0 0 13 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.8043 6.474H1.6483L1.8823 4.764H8.0383L8.3803 2.37H1.5403L1.7743 0.678H12.0343L10.7563 9.696C10.7083 10.044 10.5463 10.338 10.2703 10.578C10.0063 10.806 9.7063 10.92 9.3703 10.92H0.334297L0.586297 9.21H7.4083L7.8043 6.474Z"
                      fill="#F5F5F5"
                    />
                  </svg>
                </div>
              </div>
              <div>
                <div>
                  <svg
                    width="13"
                    height="11"
                    viewBox="0 0 13 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.57213 0.678H6.49613L4.62413 7.158H7.28813L8.11613 1.344L7.52213 0.678H11.6261L10.7081 7.158H12.0761L11.8421 8.868H10.4741L10.1861 10.92H6.76613L7.05413 8.868H0.916133L1.15013 7.158L2.96813 1.11L2.57213 0.678Z"
                      fill="#F5F5F5"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="steps-content">
              <div v-for="(item, index) in saleList" :key="index">
                <div
                  v-for="item2 in item"
                  :key="item2.text"
                  :class="[item2.extraClass || '', 'steps-content-item']"
                  @click="navTo(item2)"
                >
                  <div>{{ item2.text }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="平台采购业务" name="1">
            <div class="purchase-steps-content">
              <div>
                <div>配置采购权限</div>
                <div class="steps-content-item">
                  <div>维护组织架构</div>
                </div>
                <div class="steps-content-item">
                  <div>维护角色权限</div>
                </div>
                <div class="steps-content-item">
                  <div>维护企业员工</div>
                </div>
              </div>
              <div>
                <div>配置采购信息</div>
                <div>
                  <div class="steps-content-item">
                    <div>维护地址信息</div>
                  </div>
                  <div class="steps-content-item">
                    <div>维护发票信息</div>
                  </div>
                </div>
                <div>
                  <div class="steps-content-item plain">
                    <div>开通在线支付</div>
                  </div>
                  <div class="steps-content-item plain">
                    <div>设置审批流程</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="home-service">
      <div>综合服务</div>
      <div>
        <div v-for="item in list" :key="item.text">
          <icon-animation v-if="item.img" :bg-url="item.img" />
          <div>{{ item.text }}</div>
          <div
            :class="[item.btnText === '申请' ? 'btn-80-30-plain' : 'btn-80-30']"
            @click="toOpen(item)"
          >
            {{ item.btnText }}
          </div>
        </div>
      </div>
    </div>
    <!--        <div class="home-class">-->
    <!--            <div>-->
    <!--                <span>易学院</span>-->
    <!--                <e-btn-animation btnHeight="30" fontSize="12" btnWidth="80" title="立即进入"/>-->
    <!--            </div>-->
    <!--            <div>-->
    <!--                <div>-->
    <!--                    <img src="../../../../assets/img/home/video.png" alt="">-->
    <!--                    <div>课程名称课程名称课程名称课程名课程名称课程名称课程名称课程名课程名称课程名称课程名称课程名</div>-->
    <!--                    <div>课程简介文字课程简介文字课程，简文啊简文啊课程简介文字课程简介。课程简介文字课程简介文字课程。</div>-->
    <!--                    <div>2021-06-04</div>-->
    <!--                </div>-->
    <!--                <div>-->
    <!--                    <div v-for="item in classList" :key="item.id">-->
    <!--                        <div>{{item.title}}</div>-->
    <!--                        <div>{{item.date}}</div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <BottomScroller></BottomScroller>
    <ChangePassword></ChangePassword>
    <ChangeUsername></ChangeUsername>
    <LiabilityBook></LiabilityBook>
    <!-- 合规承诺协议 -->
    <compliance-commitment
      :compliance-data="complianceData"
    ></compliance-commitment>
  </div>
</template>

<script>
import BottomScroller from '@/components/common/bottomScroller';
import ChangePassword from '@/components/common/changePassword';
import ChangeUsername from '@/components/common/changeUsername';
import LiabilityBook from '@/components/common/liabilityBook';
import { mapGetters } from 'vuex';
import complianceCommitment from '@/components/common/complianceCommitment';
import { USER_TYPE, ADMIN } from './constant';
import { easySeries, insuranceUrl, epecMallUrl } from '../../api/config';
import EBtnAnimation from '../../components/common/e-btn-animation';
import IconAnimation from './iconAnimation';
import api from '../../api/home';
import userApi from '../../api/user';
import orderApi from '../../api/order';
import cmsApi from '../../api/cms';
import authorityApi from '../../api/authority';
import { IEVersion } from '../../utils/utils';

export default {
  name: 'Dashboard',
  components: {
    EBtnAnimation,
    IconAnimation,
    BottomScroller,
    ChangePassword,
    ChangeUsername,
    LiabilityBook,
    complianceCommitment,
  },
  props: {},
  data() {
    return {
      activityInviteInfo: {},
      epecMallUrl,
      easySeries,
      companyName: '',
      quickNavActive: '0',
      quickNavHidden: false,
      USER_TYPE,
      outsideOrderPurchase: {
        // 外销采购订单
        approveCount: 0, // 待审批数量
        confirmCount: 0, // 待采购商确认数量
        paymentCount: 0, // 待付款数量
        receiveCount: 0, // 待收货数量
      },
      outsideOrderSupply: {
        confirmCount: 0, // 待确认
        paymentCount: 0, // 待收款
        sendCount: 0, // 待发货
      },
      saleList: [
        [
          {
            text: '收款账号维护',
            extraClass: 'plain',
            url: '',
          },
          {
            text: '交易参数设置',
            extraClass: '',
            url: '',
          },
        ],
        [
          {
            text: '产品目录申请',
            url: '',
          },
          {
            text: '查看目录审核进度',
            url: '',
          },
          {
            text: '申请成功',
            extraClass: 'disabled',
            url: '',
          },
        ],
        [
          {
            text: '外销商品发布',
            url: '',
          },
          {
            text: '外销商品维护',
            url: '',
          },
          {
            text: '规格属性申请',
            extraClass: 'plain',
            url: '',
          },
          {
            text: '销售区域管理',
            url: '',
          },
        ],
        [
          {
            text: '订单确认',
            url: '',
          },
          {
            text: '订单发货',
            url: '',
          },
          {
            text: '开票管理',
            url: '',
          },
          {
            text: '售后管理',
            url: '',
          },
        ],
      ],
      isOpeningPayment: true,
      isAuthentication: false,
      administrator: ADMIN.NO,
      userType: '',
      classList: [
        {
          id: 0,
          title: '课程名称课程名称课程名称课程名称课程名称课程',
          date: '2021-06-04',
        },
        {
          id: 1,
          title: '课程名称课程名称课程名称课程名称课程名称课程',
          date: '2021-06-04',
        },
        {
          id: 2,
          title: '课程名称课程名称课程名称课程名称课程名称课程',
          date: '2021-06-04',
        },
        {
          id: 3,
          title: '课程名称课程名称课程名称课程名称课程名称课程',
          date: '2021-06-04',
        },
        {
          id: 4,
          title:
            '课程名称课程名称课程名称课程名称课程名称课程课程名称课程名称课程名称课程名称课程名称课程课程名称课程名称课程名称课程名称课程名称课程课程名称课程名称课程名称课程名称课程名称课程',
          date: '2021-06-04',
        },
      ],
      info: {
        creditGrade: '', // 信用评价等级
        gradeId: '', // 履约动态考评星级
        productGrade: '', // 产品质量评价
        innovationEvaluateString: '', // 市场业绩表现
        innovationEvaluateStringStutes: '', // 市场业绩表现等级
        scoreAll: '', // 易派客标准指数会员总分
        showCredit: false, // 是否展示法人信用认证
        showProductGrade: false, // 	是否展示法人信用评价
      },
      applyStatus: '',
      complianceData: {},
    };
  },
  computed: {
    ...mapGetters(['get_userInfo']),
    list() {
      let arr = [
        {
          img: require('../../../../assets/img/home/yibaoxian.png'),
          text: '易保险',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://baoxian.epec.com/toIndex
          url: `${insuranceUrl}/toIndex`,
        },
        {
          img: require('../../../../assets/img/home/yizhifu.png'),
          text: '易支付',
          btnText: this.isOpeningPayment ? '查看' : '申请',
          hidden: this.administrator !== ADMIN.YES, // 仅限管理员申请，申请后显示查看按钮，其它身份不显示。
          // url: `https://10.248.67.159/`
          url: `/paymentAccount`,
        },
        {
          img: require('../../../../assets/img/home/yibaoli.png'),
          text: '易保理',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/supplier/businessFactor.do
          url: `${easySeries}/ecmall/supplier/businessFactor.do`,
        },
        {
          img: require('../../../../assets/img/home/yiquantong.png'),
          text: '易权通',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/staticHtmls/ebillManager.do
          url: `${easySeries}/ecmall/staticHtmls/ebillManager.do`,
        },
        {
          img: require('../../../../assets/img/home/yiwuliu.png'),
          text: '易物流',
          btnText: '申请',
          hidden: false, // 仅限供应商管理员申请，按钮一直显示申请，其它身份跳转宣传页https://mall.epec.com/ecmall/static/logistics.do
          url: `${easySeries}/ecmall/static/logistics.do`,
          // url: [USER_TYPE.ALL, USER_TYPE.SUPPLY].includes(this.userType) && this.administrator === ADMIN.YES ? `${url.oldService}/memberportal/zh/companyTransport/init.do` : `${url.easySeries}/ecmall/static/logistics.do`
        },
        {
          img: require('../../../../assets/img/home/yishanglv.png'),
          text: '易派客商旅',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/epecTravel/epecTravel.do
          url: `${easySeries}/ecmall/epecTravel/epecTravel.do`,
        },
        {
          img: require('../../../../assets/img/home/yishenghuo.png'),
          text: '易生活',
          btnText: '查看',
          hidden: false, // 无权限控制，全部身份用户均显示，只显示查看按钮，都跳转宣传页https://mall.epec.com/ecmall/static/xfpZone.do
          url: `https://emall.epec.com/brandMall?companyId=5528459&columeId=3&shopId=125&companyName=%E6%98%93%E6%B4%BE%E5%AE%A2%E7%94%B5%E5%AD%90%E5%95%86%E5%8A%A1%EF%BC%88%E6%B5%B7%E5%8D%97%EF%BC%89%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8`,
          // url: `${easySeries}/ecmall/static/xfpZone.do`
        },
        {
          img: require('../../../../assets/img/home/yirenzheng.png'),
          text: '易认证',
          btnText: this.isAuthentication ? '查看' : '申请',
          hidden:
            USER_TYPE.PERSONAL === this.userType ||
            this.administrator === ADMIN.NO, // 仅限管理员申请，申请后显示查看按钮，其它身份不显示。
          url: `${easySeries}/ecmall/knowledgeInnovation/showKnowledgeInnovationAbilityEvaluation.do`,
        },
      ];
      arr = arr.filter((item) => !item.hidden);
      return [...arr];
    },
    paddingBottom() {
      return IEVersion() ? '20px' : '10px';
    },
    num() {
      return (n) => (n > 999 ? '999+' : n || 0);
    },
  },
  watch: {
    get_userInfo: {
      immediate: true,
      handler(userInfo) {
        if (!userInfo.companyId) {
          return;
        }
        this.companyName = userInfo.companyName;
        switch (userInfo.memberIdentity) {
          case 'supplier':
            this.userType = USER_TYPE.SUPPLY;
            break;
          case 'purchase':
            this.userType = USER_TYPE.PURCHASE;
            break;
          case 'double_identity':
            this.userType = USER_TYPE.ALL;
            break;
          default:
            break;
        }
        this.administrator = userInfo.isAdmin;
        if (this.userType !== USER_TYPE.PERSONAL) {
          this.queryOpeningPayment();
          this.queryOpeningAuthentication();
          this.queryCompanyGradeInfo();
          this.queryUserApplyStatus();
        }
        if ([USER_TYPE.ALL, USER_TYPE.PURCHASE].includes(this.userType)) {
          this.purchaseOrderStatistic(1);
        }
        if ([USER_TYPE.ALL, USER_TYPE.SUPPLY].includes(this.userType)) {
          this.purchaseOrderStatistic(2);
        }
        const token = this.$cookies.get('epecToken');
        const { companyId } = userInfo;
        if (token && companyId) {
          this.getCompliance();
        }
      },
    },
  },
  created() {
    localStorage.setItem('firstIndex', 10136);
    this.queryCompanyActivityInviteInfo();
  },

  methods: {
    // 获取活动日期
    async queryCompanyActivityInviteInfo() {
      await cmsApi.queryCompanyActivityInviteInfo({}).then((res) => {
        if (res.code === '200') {
          this.activityInviteInfo = res.data || {};
        }
      });
    },
    toRegister() {
      this.$router.push({ path: '/activityNotification' });
    },
    jump(url, type) {
      if (type === 1) {
        this.$router.push({ path: url });
        return;
      }
      window.open(url);
    },
    toPurchase() {
      this.$router.push({ path: '/exclusivePurchase' });
    },
    turnNumber(n) {
      return Number(n || 0);
    },
    async queryOpeningPayment() {
      const res = await api.queryOpeningPayment();
      if (res.success) {
        this.isOpeningPayment = res.data;
      }
    },
    async queryOpeningAuthentication() {
      const res = await api.queryOpeningAuthentication();
      if (res.success) {
        this.isAuthentication = res.data;
      }
    },
    async queryCompanyGradeInfo() {
      const res = await api.queryCompanyGradeInfo();
      if (res.success) {
        if (res.data && JSON.stringify(res.data) !== '{}') {
          this.info = res.data;
        }
      }
    },
    toOpen(data) {
      if (data.url) {
        if (data.url.substr(0,4) !== 'http') {
          this.$router.push({
            path: data.url
          })
        } else {
          window.open(data.url);
        }
      }
    },
    navTo(data) {
      if (data.text == '外销商品维护' && data.url == '/goodsMaintenance') {
        authorityApi
          .queryBackButton({ authCode: '/goodsMaintenance' })
          .then((res) => {
            this.$store.commit('button_directive', res.data);
            this.$router.push({ path: data.url });
          });
      } else {
        data.url && this.$router.push({ path: data.url });
      }
    },
    async queryUserApplyStatus() {
      const res = await userApi.queryUserApplyStatus();

      // 101审核中 102 审核通过 103 审核拒绝'
      if (res.data) {
        this.applyStatus = res.data;
      }
    },
    /**
     * 外销订单
     * @param companyType
     * @returns {Promise<void>}
     */
    async purchaseOrderStatistic(companyType) {
      const res = await orderApi.purchaseOrderStatistic({
        companyType,
      });
      if (res.success) {
        if (companyType === 1) {
          this.outsideOrderPurchase = res.data;
        } else {
          this.outsideOrderSupply = res.data;
        }
      }
    },
    // 合规承诺-系统弹框
    async getCompliance() {
      const res = await userApi.checkAgreementConformance();
      console.log(res);
      if (res.code === '200') {
        this.complianceData = res.data || {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.home-container {
  /*font-family: Source Han Sans CN;*/
  padding: 10px 10px 0;
  min-width: 1060px;

  .register-info-wrapper {
    width: 100%;
    height: 100px;
    background: url('../../../../assets/img/home/messageNotification.png')
      center center no-repeat;
    background-size: 100%;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    .info-detail {
      color: #2587ff;
    }
    .to-register {
      cursor: pointer;
      border-bottom: 1px solid transparent;
      &:hover {
        border-bottom: 1px solid #2587ff;
      }
    }
  }

  .home-companyName {
    font-weight: bold;
    color: $c3;
    font-size: 24px;
    line-height: 1;
    margin-bottom: 20px;
  }

  .home-index {
    > div:nth-child(1) {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 20px;

      span {
        display: inline-block;
        line-height: 1;
        vertical-align: bottom;
      }

      > span:nth-child(2) {
        margin-left: 5px;
        color: #50aa43;
      }

      > span:nth-child(4) {
        color: $main-col;
        font-size: 30px;
      }
    }

    > div:nth-child(2) {
      height: 104px;
      display: flex;

      > div {
        flex: 1;
        margin-right: 21px;
        display: flex;
        background: #ffffff;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

        &:last-child {
          margin-right: 0;
        }

        > div:nth-child(1) {
          width: 104px;
          height: 104px;
          padding: 12px;
          background: #f4f7ff;
        }

        > div:nth-child(2) {
          padding: 20px 0 0 20px;

          > div:nth-child(1) {
            font-size: 14px;
            font-weight: bold;
            color: $c3;
            margin-bottom: 21px;
          }
        }

        &.not-support {
          background: #f5f5f5;

          path {
            fill: #cccccc;
          }

          > div:nth-child(1) {
            background: #f5f5f5;
          }

          > div:nth-child(2) {
            color: #c5c5c5;

            > div:nth-child(1) {
              color: #c5c5c5;
            }

            > div:nth-child(2) {
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .home-pending {
    display: flex;
    /*height: 204px;*/
    margin-top: 20px;

    > div {
      padding: 20px;
      background: #ffffff;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

      > div:nth-child(1) {
        background: url('../../../../assets/img/home/pending-icon.png')
          no-repeat left center;
        background-size: 20px 20px;
        padding-left: 30px;
        line-height: 20px;
      }

      > div:nth-child(2) {
        > div:nth-child(1),
        > div:nth-child(2) {
          display: flex;
          margin-top: 20px;

          > div {
            flex: 1;
            line-height: 1;

            > div:nth-child(1) {
              cursor: pointer;
              font-size: 30px;
              font-weight: bold;
              color: $c3;
              margin-bottom: 10px;
            }

            > div:nth-child(2) {
              color: $c9;
              font-size: 12px;
            }
          }
        }
      }
    }

    .home-pending-only {
      display: flex;

      > div {
        flex: 1;
      }
    }

    .home-pending-sale {
      flex: 2;
    }

    .home-pending-purchase {
      flex: 4;

      .home-pending-only {
        > div:nth-child(1) {
          flex: 3;
        }

        > div:nth-child(2) {
          flex: 2;
        }
      }
    }

    .home-pending-sale + div {
      margin-left: 20px;
    }
  }

  .home-business {
    display: flex;
    margin-top: 20px;

    > div {
      flex: 1;
      height: 80px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-between;
      background: #ffffff;

      & + div {
        margin-left: 20px;
      }

      > div:nth-child(1) {
        width: 271px;
        height: 80px;
        line-height: 80px;
        background: url('../../../../assets/img/home/left-bg.png') no-repeat;
        padding-left: 32px;

        > img {
          vertical-align: middle;
        }

        > span {
          margin-left: 16px;
          font-size: 16px;
          font-weight: bold;
          color: $main-col;
        }
      }

      > div:nth-child(2) {
        width: 197px;
        height: 80px;
        padding-right: 30px;
        padding-top: 25px;
        background: url('../../../../assets/img/home/right-bg.png') no-repeat;

        > div {
          float: right;
        }
      }
    }

    > div:nth-child(2) {
      > div:nth-child(1) {
        > span {
          margin-left: 23px;
        }
      }

      > div:nth-child(2) {
        background: url('../../../../assets/img/home/right-bg-2.png') no-repeat
          right;
      }
    }
  }

  .home-quick-nav {
    margin-top: 20px;
    background: #ffffff;
    padding: 0 20px 10px;
    position: relative;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .quickNavHidden {
      margin-top: -264px;

      .tab-extra {
        margin-top: -264px;
      }
    }

    > div:nth-child(2) {
      transition: margin-top 0.3s linear;
      margin-bottom: 10px;
    }

    > div:nth-child(1) {
      padding-top: 20px;
      padding-bottom: 10px;
      position: relative;
      background: url('../../../../assets/img/home/pending-icon.png') #ffffff
        no-repeat left 20px;
      padding-left: 30px;
      line-height: 20px;
      cursor: pointer;
      z-index: 3;

      > span:nth-child(1) {
        margin-right: 20px;
        font-size: 14px;
        color: $c3;
      }

      > span:nth-child(2) {
        font-size: 12px;
        color: #000000;
        font-weight: bold;
        margin-right: 1px;
      }

      > span:nth-child(3) {
        font-size: 12px;
        color: $c9;
      }

      img {
        position: absolute;
        top: 50%;
        right: 0;

        &.rotate {
          transform: rotate(180deg);
        }
      }
    }

    .tab-extra {
      position: absolute;
      top: 70px;
      right: 20px;
      width: 220px;
      height: 12px;
      line-height: 12px;
      text-align: right;
      transition: margin-top 0.3s linear;

      > span {
        display: inline-block;
        font-size: 12px;
        vertical-align: middle;
        color: $c9;
      }

      > span:nth-child(1),
      > span:nth-child(3) {
        width: 12px;
        height: 12px;
        margin-right: 10px;
      }

      > span:nth-child(1) {
        border: 1px solid $main-col;
      }

      > span:nth-child(3) {
        margin-left: 20px;
        border: 1px dashed $main-col;
      }
    }

    .steps {
      height: 40px;
      position: relative;
      background: url('../../../../assets/img/home/dashed.png') repeat left
        center;
      display: flex;

      > div {
        text-align: center;
        flex: 1;
        margin-right: 20px;
        position: relative;
        padding-top: 10px;

        &:last-child {
          margin-right: 0;
        }

        &:before {
          width: 9px;
          height: 12px;
          position: absolute;
          left: 49px;
          top: 14px;
          content: ' ';
          background-image: url('../../../../assets/img/home/gray-arrow.png');
          background-size: 9px 12px;
        }

        &:after {
          width: 9px;
          height: 12px;
          position: absolute;
          right: 49px;
          top: 14px;
          content: ' ';
          background-image: url('../../../../assets/img/home/gray-arrow.png');
          background-size: 9px 12px;
        }

        > div {
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: #ffffff;
          background: $main-col;
          text-align: center;

          > svg {
            margin-top: 4px;
            vertical-align: top;
          }
        }
      }
    }

    .steps-content {
      width: 100%;
      height: 172px;
      display: flex;

      > div {
        height: 100%;
        background: #f4f7ff;
        flex: 1;
        margin-right: 20px;
        padding-top: 10px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .steps-content-item {
      text-align: center;
      margin: 0 auto 10px;
      width: 130px;
      height: 30px;
      line-height: 28px;
      border: 1px solid rgba(37, 135, 255, 0.59);
      transform: skewX(-15deg);
      position: relative;
      font-size: 14px;
      color: $main-col;
      background: #ffffff;

      &:hover {
        background: $main-col;
        color: #ffffff;
      }

      &.disabled {
        cursor: none;
        color: $c9;
        border: 1px solid #d9d9d9;

        &:hover {
          line-height: 28px;
          cursor: auto;
          color: $c9;
          background: transparent;
          border: 1px solid #d9d9d9;
        }
      }

      &.plain {
        line-height: 26px;
        border: 2px dashed $main-col;
      }

      > div {
        width: 100%;
        height: 100%;
        transform: skewX(15deg);

        &:before {
          width: 2px;
          height: 7px;
          content: ' ';
          position: absolute;
          bottom: -7px;
          left: 50%;
          margin-left: -1px;
          background: linear-gradient(
            to bottom,
            transparent 0%,
            transparent 14%,
            $main-col 14%,
            $main-col 42%,
            transparent 42%,
            transparent 70%,
            $main-col 70%,
            $main-col 100%
          );
        }

        &:after {
          content: ' ';
          position: absolute;
          bottom: -11px;
          left: 50%;
          margin-left: -4px;
          border-top: 4px solid $main-col;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
        }
      }

      &:last-child {
        > div {
          &:after,
          &:before {
            content: none;
          }
        }
      }
    }

    .purchase-steps-content {
      display: flex;
      padding-top: 20px;

      > div {
        flex: 1;
        background: #f4f7ff;
        margin-right: 20px;
        padding-top: 20px;
        height: 192px;

        > div:nth-child(1) {
          text-align: center;
          line-height: 1;
          font-size: 14px;
          margin-bottom: 16px;
        }

        .steps-content-item {
          margin-bottom: 18px;

          > div {
            &:before {
              height: 14px;
              bottom: -14px;
            }

            &:after {
              bottom: -19px;
            }
          }
        }

        &:last-child {
          margin-right: 0;
        }
      }

      > div:nth-child(2) {
        > div:nth-child(2),
        > div:nth-child(3) {
          margin: 0 auto;
          width: 284px;
          display: flex;
          justify-content: space-between;
        }

        > div:nth-child(2) {
          margin-top: 32px;
          margin-bottom: 2px;
        }

        .steps-content-item {
          > div {
            &:after,
            &:before {
              content: none;
            }
          }
        }
      }
    }
  }

  .home-service {
    padding: 0 20px;
    background: #ffffff;
    margin-top: 20px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    > div:nth-child(1) {
      padding: 20px 30px;
      background: url('../../../../assets/img/home/service-icon.png') #ffffff
        no-repeat left center;
    }

    > div:nth-child(2) {
      display: flex;
      padding-bottom: 20px;

      > div {
        flex: 1;
        margin-right: 20px;
        border: 1px solid #d9d9d9;
        text-align: center;
        padding-top: 20px;
        padding-bottom: 20px;

        > img {
          vertical-align: top;
        }

        > div:nth-child(2) {
          font-weight: bold;
          font-size: 16px;
          line-height: 16px;
          margin: 10px 0 20px;
        }

        > div:nth-child(3) {
          margin: 0 auto;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .home-class {
    padding: 0 20px 20px;
    background: #ffffff;
    margin-top: 20px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    > div:nth-child(1) {
      padding: 20px 0 20px 30px;
      background: url('../../../../assets/img/home/pending-icon.png') #ffffff
        no-repeat left 20px;
      display: flex;
      justify-content: space-between;
      line-height: 20px;
    }

    > div:nth-child(2) {
      display: flex;

      > div:nth-child(1) {
        width: 260px;
        margin-right: 20px;
        cursor: pointer;

        > div:nth-child(2) {
          margin-top: 13px;
          font-size: 16px;
          color: $c3;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        > div:nth-child(3) {
          line-height: 1.5;
          font-size: 12px;
          color: $c9;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        > div:nth-child(4) {
          color: $c9;
          font-size: 14px;
          line-height: 1;
          margin-top: 11px;
        }

        &:hover,
        &:active {
          > div:nth-child(2) {
            color: $main-col;
          }
        }
      }

      > div:nth-child(2) {
        width: calc(100% - 280px);
        border: 1px solid #d9d9d9;

        > div {
          border-bottom: 1px solid #d9d9d9;
          line-height: 50px;
          display: flex;
          padding: 0 20px;
          cursor: pointer;

          &:hover {
            background: #f4f7ff;
          }

          &:last-child {
            border-bottom: none;
          }

          > div:nth-child(1) {
            width: calc(100% - 82px);
            margin-right: 20px;
            color: $c3;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          > div:nth-child(2) {
            text-align: right;
            width: 82px;
            color: $c9;
            font-size: 12px;
          }
        }
      }
    }
  }
}

::v-deep {
  .el-rate__icon {
    font-size: 20px;
    margin-right: 2px;
  }

  .tabs-area {
    width: 100%;

    .el-tabs__nav {
      border-radius: 0;
    }

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav .el-tabs__item {
      width: 170px;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      height: 40px;

      &.is-active {
        background: #f4f7ff;
        color: #0064c8;
      }

      &.is-active::after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        content: '';
        width: 100%;
        height: 2px;
        background: #0064c8;
      }
    }
  }
}

.btn-80-30 {
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 28px;
  border: 1px solid #c5c5c5;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    border: 1px solid $main-col;
    color: $main-col;
  }
}

.btn-80-30-plain {
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 28px;
  border: 1px solid $main-col;
  cursor: pointer;
  font-size: 14px;
  color: $main-col;

  &:hover {
    background: #e8efff;
    color: $main-col;
  }
}

.btn-80-30-primary {
  padding: 0;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  font-size: 12px;

  img {
    margin-left: 4px;
  }
}
</style>
